import store from "../controller/baseController";
import Enums from "../enums/enums";
import peakUtility from "../function/peakUtility.js";
import i18n from "../locales/i18n";
import paymentHelper from "./paymentHelper";
let vatPercent = 7;
let inputMaxNumber = 999999999.9999;
let inputMinNumber = -999999999.9999;
function GetPageTransactionItemByPageSize(indexTransactionItem, pageSize) {
  let pageNo = parseInt(indexTransactionItem / pageSize);
  pageNo += indexTransactionItem % pageSize > 0 ? 1 : 0;
  return pageNo;
}
function GetPageErrorListfromTransaction(transaction) {
  let pageErrorList = [];
  if (transaction && transaction.transactionItemList && transaction.transactionItemList.length > 0) {
    transaction.transactionItemList.forEach((transactionItem, index) => {
      let sequenceNumber = index + 1;
      if (transactionItem.isValidateError || transactionItem.description.validateError) {
        let page = GetPageTransactionItemByPageSize(sequenceNumber, transaction.pageSize);
        let selectPageError = pageErrorList.find((x) => x.page === page);
        if (selectPageError) {
          selectPageError.sequenceNumberList.push(sequenceNumber);
        } else {
          pageErrorList.push({ page: page, sequenceNumberList: [sequenceNumber] });
        }
      }
    });
  }
  return pageErrorList;
}
function SlideToElementError(transaction) {
  let numberValidateError = transaction.number.validateError;
  let referenceValidateError = transaction.reference.validateError;
  let transactionListValidateError = transaction.isValidateError;
  let contactValidateError = transaction.contact.validateError || transaction.contact.id === 0;
  let dateValidateError = !transaction.date.value || transaction.date.value === "";
  let dueDateValidateError = false;
  let transactionCurrencySummaryVatIsActive = false;
  let returnStockTypeValidateError = false;
  let reasonDescriptionValidateError = false;
  let reasonTypeValidateError = false;
  if (
    transaction.transactionType == Enums.TransactionType.CreditNote ||
    transaction.transactionType == Enums.TransactionType.DebitNote
  ) {
    returnStockTypeValidateError = transaction.returnStock.validateError || transaction.returnStock.value.id == 0;
    reasonDescriptionValidateError =
      transaction.reasonDescription.validateError ||
      transaction.reasonDescription.text == null ||
      transaction.reasonDescription.text.trim() == "";
    reasonTypeValidateError = transaction.reasonType.value == null || transaction.reasonType.value.id == 0;
  }
  if (
    transaction.transactionType === Enums.TransactionType.Invoice ||
    transaction.transactionType === Enums.TransactionType.Quotation
  ) {
    dueDateValidateError =
      !transaction.dueDate.value || transaction.dueDate.value === "" || transaction.dueDate.validateError;
  }

  if (transaction.transactionCurrencySummary.vat) {
    transactionCurrencySummaryVatIsActive = transaction.transactionCurrencySummary.vat.isActive;
  }
  let netAmountValidateError = transaction.transactionSummary.netAmount.ToNumber() < 0 ? true : false;
  let paymentValidateError = transaction.payment ? transaction.payment.isValidateError : false;
  let remarkValidateError = transaction.remark ? transaction.remark.validateError : false;
  let elementId = "";

  if (numberValidateError || referenceValidateError) {
    elementId = "headPage";
  } else if (contactValidateError || dateValidateError || dueDateValidateError) {
    elementId = "contactInformation";
  } else if (transactionListValidateError) {
    elementId = "dataList";
  } else if (transactionCurrencySummaryVatIsActive) {
    elementId = "dataSummary";
  } else if (paymentValidateError) {
    AlertPaymentValidateError(transaction);
    elementId = "PaymentGatewayEditDocument";
  } else if (remarkValidateError) {
    elementId = "RecordExternal";
  } else if (returnStockTypeValidateError || reasonDescriptionValidateError || reasonTypeValidateError) {
    elementId = "creditNoteDebitNoteReasonEditDocument";
  }
  if (document.getElementById(elementId)) {
    document.getElementById(elementId).scrollIntoView({ behavior: "smooth", block: "center" });
  }
}
function AlertPaymentValidateError(transaction) {
  let paymentAllGroupTotal = transaction.payment.paymentAllGroupTotal.ToNumber().ToAccountingRoundUpNumber();
  let netAmount = transaction.transactionSummary.remainPaymentNetAmount.ToNumber().ToAccountingRoundUpNumber();

  if (
    (transaction.transactionType === Enums.TransactionType.Receipt &&
      transaction.financeType === Enums.FinanceType.InFlow) ||
    (transaction.transactionType === Enums.TransactionType.CreditNote && transaction.reference.referenceId > 0) ||
    transaction.transactionType === Enums.TransactionType.BillingNote
  ) {
    if (paymentAllGroupTotal !== netAmount) {
      store.dispatch("SetAlertMessage", {
        alertMessage: i18n.t("Total_Payment_Must_Be_Equal_To_Net_Amount"),
        typeMessage: Enums.TypeComponentNoti.error,
      });
    }
  }
}
function TransactionValidationAndRemoveTransactionItemEmpty(
  transaction,
  triggerAlert = true,
  isImportTransaction = false
) {
  return TransactionValidationAndRemoveTransactionItemEmptyBase(transaction, triggerAlert, isImportTransaction, false);
}
function BookmarkValidation(transaction) {
  return TransactionValidationAndRemoveTransactionItemEmptyBase(transaction, true, false, true);
}
function CheckTransactionItemIsNotEmpty(transaction) {
  let transactionItemIsCheck = false;

  if (transaction && transaction.transactionItemList && transaction.transactionItemList.length > 0) {
    transactionItemIsCheck = transaction.transactionItemList.some(
      (transactionItem) => transactionItem.checked.value === true
    );
  }

  if (!transactionItemIsCheck) {
    store.dispatch("SetAlertMessage", {
      alertMessage: i18n.t("Please_Select_Product_Service_At_Least_One_Transaction"),
      typeMessage: Enums.TypeComponentNoti.error,
    });
  }

  return transactionItemIsCheck ? true : false;
}
function TransactionValidationInvoice(transaction) {
  let isTransactionItemValidate = true;

  if (
    transaction.transactionType == Enums.TransactionType.Invoice &&
    transaction.reference.referenceTypeId == Enums.TransactionType.Quotation &&
    transaction.reference.referenceId > 0
  ) {
    isTransactionItemValidate = CheckTransactionItemIsNotEmpty(transaction);
  }

  return isTransactionItemValidate;
}
function GetCreditNoteActualTotal(transactionReferenceAmount, vatExemptedTotal, zeroVatTotal, preVatTotal) {
  return transactionReferenceAmount
    .ToNumber()
    .Subtract(
      vatExemptedTotal
        .ToNumber()
        .Add(zeroVatTotal.ToNumber())
        .Add(preVatTotal.ToNumber())
    )
    .ToAccountingRoundUpNumber();
}
function GetDebitNoteActualTotal(transactionReferenceAmount, vatExemptedTotal, zeroVatTotal, preVatTotal) {
  return transactionReferenceAmount
    .ToNumber()
    .Add(vatExemptedTotal.ToNumber())
    .Add(zeroVatTotal.ToNumber())
    .Add(preVatTotal.ToNumber())
    .ToAccountingRoundUpNumber();
}
function TransactionValidationDebitNoteCreditNote(transaction) {
  let isTransactionItemValidate = true;
  let isNewAmountValidate = true;
  if (
    (transaction.transactionType == Enums.TransactionType.CreditNote ||
      transaction.transactionType == Enums.TransactionType.DebitNote) &&
    transaction.reference.referenceId > 0
  ) {
    isTransactionItemValidate = CheckTransactionItemIsNotEmpty(transaction);
  }

  let totalDocumentAmountAfterCreditNote = 0;
  if (transaction.transactionType == Enums.TransactionType.CreditNote) {
    totalDocumentAmountAfterCreditNote = GetCreditNoteActualTotal(
      transaction.transactionReferenceAmount.value,
      transaction.transactionCurrencySummary.vatExemptedTotal,
      transaction.transactionCurrencySummary.zeroVatTotal,
      transaction.transactionCurrencySummary.vat.preVatTotal
    );
  } else if (transaction.transactionType == Enums.TransactionType.DebitNote) {
    totalDocumentAmountAfterCreditNote = GetDebitNoteActualTotal(
      transaction.transactionReferenceAmount.value,
      transaction.transactionCurrencySummary.vatExemptedTotal,
      transaction.transactionCurrencySummary.zeroVatTotal,
      transaction.transactionCurrencySummary.vat.preVatTotal
    );
  }

  if (totalDocumentAmountAfterCreditNote < 0) {
    isNewAmountValidate = false;
  }

  if (!isNewAmountValidate) {
    store.dispatch("SetAlertMessage", {
      alertMessage: i18n.t("New_Amount_Must_Be_Greater_Than_Or_Equal_To_0"),
      typeMessage: Enums.TypeComponentNoti.error,
    });
  }

  return isTransactionItemValidate && isNewAmountValidate;
}
function TransactionValidationAndRemoveTransactionItemEmptyBase(
  transaction,
  triggerAlert = true,
  isImportTransaction = false,
  isBookmarkValidate = false
) {
  let numberValidateError = false;
  if (!isBookmarkValidate) {
    if (isImportTransaction) {
      numberValidateError = transaction.number.validateError;
    } else {
      numberValidateError = transaction.number.value === "" || transaction.number.validateError;
    }
  }
  let referenceValidateError = transaction.reference.validateError;
  let transactionListValidateError = false;
  let contactValidateError = false;
  let dateValidateError = !transaction.date.value || transaction.date.validateError;
  let dueDateValidateError = false;
  let netAmountValidateError = transaction.transactionSummary.netAmount.ToNumber() < 0 ? true : false;
  let paymentValidateError = false;
  let remarkValidateError = transaction.remark ? transaction.remark.validateError : false;
  let purchaseTaxInvoiceValidateError = false;
  let transactionCurrencySummaryVatIsActive = false;
  let receivedTaxInvoiceValidateError = transaction.receivedTaxInvoice
    ? transaction.receivedTaxInvoice.validateError
    : false;
  let returnStockTypeValidateError = false;
  let reasonDescriptionValidateError = false;
  let reasonTypeValidateError = false;

  if (
    transaction.transactionType == Enums.TransactionType.CreditNote ||
    transaction.transactionType == Enums.TransactionType.DebitNote
  ) {
    returnStockTypeValidateError = transaction.returnStock.validateError || transaction.returnStock.value.id == 0;
    reasonDescriptionValidateError =
      transaction.reasonDescription.validateError ||
      transaction.reasonDescription.text == null ||
      transaction.reasonDescription.text.trim() == "";
    reasonTypeValidateError = transaction.reasonType.value == null || transaction.reasonType.value.id == 0;
  }

  if (
    transaction.transactionType !== Enums.TransactionType.TaxInvoice &&
    !(
      transaction.transactionType === Enums.TransactionType.Receipt &&
      (transaction.reference.referenceTypeId === Enums.TransactionType.Invoice ||
        transaction.reference.referenceTypeId === Enums.TransactionType.BillingNote)
    )
  ) {
    transactionListValidateError = transaction.isValidateError;
    if (!isBookmarkValidate) {
      contactValidateError = transaction.contact.validateError || transaction.contact.id === 0;
    }
    if (transaction.transactionCurrencySummary.vat) {
      transactionCurrencySummaryVatIsActive = transaction.transactionCurrencySummary.vat.isActive;
    }
  }
  if (
    !(
      transaction.transactionType === Enums.TransactionType.Quotation ||
      transaction.transactionType === Enums.TransactionType.TaxInvoice
    ) ||
    (transaction.transactionType === Enums.TransactionType.Receipt &&
      (transaction.reference.referenceTypeId === Enums.TransactionType.Invoice ||
        transaction.reference.referenceTypeId === Enums.TransactionType.BillingNote) &&
      transaction.reference.paymentGroupId !== 0)
  ) {
    paymentHelper.ValidationAllPaymentGroup(transaction, transaction.transactionType, transaction.financeType);
    paymentValidateError = transaction.payment ? transaction.payment.isValidateError : false;
  }
  if (
    transaction.transactionType === Enums.TransactionType.Invoice ||
    (transaction.transactionType === Enums.TransactionType.Quotation &&
      transaction.financeType === Enums.FinanceType.InFlow)
  ) {
    dueDateValidateError = !transaction.dueDate.value || transaction.dueDate.validateError;
  }
  let returnTransactionValidateError = true;
  if (
    !numberValidateError &&
    !referenceValidateError &&
    !transactionListValidateError &&
    !contactValidateError &&
    !netAmountValidateError &&
    !paymentValidateError &&
    !purchaseTaxInvoiceValidateError &&
    !dateValidateError &&
    !dueDateValidateError &&
    !transactionCurrencySummaryVatIsActive &&
    !remarkValidateError &&
    !receivedTaxInvoiceValidateError &&
    !returnStockTypeValidateError &&
    !reasonDescriptionValidateError &&
    !reasonTypeValidateError
  ) {
    returnTransactionValidateError = false;
  } else if (triggerAlert) {
    transaction.contact.validateError = contactValidateError;
    transaction.date.validateError = dateValidateError;
    transaction.number.validateError = numberValidateError;
    if (
      transaction.transactionType == Enums.TransactionType.CreditNote ||
      transaction.transactionType == Enums.TransactionType.DebitNote
    ) {
      transaction.returnStock.validateError = returnStockTypeValidateError;
      transaction.reasonType.validateError = reasonTypeValidateError;
      transaction.reasonDescription.validateError = reasonDescriptionValidateError;
    }

    if (transaction.transactionType !== Enums.TransactionType.BillingNote) {
      transaction.transactionItemList.forEach((transactionItem) => {
        if (transactionItem.description.text === "") {
          transactionItem.description.validateError = true;
        }
      });
    }
    if (transactionListValidateError) {
      let pageErrorList = GetPageErrorListfromTransaction(transaction);

      for (const pageError of pageErrorList) {
        store.dispatch("SetAlertMessage", {
          alertMessage: i18n.t("Please_Fill_In_Valid_In_Page", {
            pageNo: pageError.page,
            itemList: pageError.sequenceNumberList.join(", "),
          }),
          typeMessage: Enums.TypeComponentNoti.error,
        });
      }
    }

    if (netAmountValidateError) {
      store.dispatch("SetAlertMessage", {
        alertMessage: i18n.t("Sorry_It_Unable_Generate_File_Since_The_Total_Amount_Is_Not_An_Integer"),
        typeMessage: Enums.TypeComponentNoti.error,
      });
    }

    let allocationItemIsHaveError = transaction.transactionItemList.find((x) => x.isAllocationItemError);

    if (allocationItemIsHaveError) {
      store.dispatch("SetAlertMessage", {
        alertMessage: i18n.t("Please_Specify_Allocation_Again"),
        typeMessage: Enums.TypeComponentNoti.error,
      });
    }
  }

  if (!returnTransactionValidateError) {
    RemoveTransactionItemEmpty(transaction, triggerAlert);
  }

  return returnTransactionValidateError;
}
function RemoveTransactionItemEmpty(_transaction, triggerAlert) {
  if (
    triggerAlert &&
    _transaction.transactionType !== Enums.TransactionType.BillingNote &&
    _transaction.transactionItemList &&
    _transaction.transactionItemList.length > 1
  ) {
    let transactionItemList = _transaction.transactionItemList.filter((transactionItem) => {
      if (
        !(
          (!transactionItem.isDescriptionOnly &&
            transactionItem.account.id == 0 &&
            transactionItem.description.text == "" &&
            transactionItem.price.value.ToNumber() == 0 &&
            transactionItem.discount.value.ToNumber() == 0) ||
          (transactionItem.isDescriptionOnly && transactionItem.description.text == "")
        )
      ) {
        return transactionItem;
      }
    });

    if (transactionItemList && transactionItemList.length > 0) {
      _transaction.transactionItemList = transactionItemList;
    }
  }
}

function CheckErrorValueInput(_transaction, _isImport = false) {
  if (_transaction.transactionType != Enums.TransactionType.BillingNote) {
    _transaction.transactionItemList.forEach((transactionItem) => {
      TransactionItemValidation(transactionItem, _transaction, _isImport);
    });
    TransactionItemListValidate(_transaction, _isImport);
    SummaryValidation(_transaction);
  }
  switch (_transaction.transactionType) {
    case Enums.TransactionType.Receipt:
    case Enums.TransactionType.Invoice:
    case Enums.TransactionType.CreditNote:
    case Enums.TransactionType.DebitNote:
    case Enums.TransactionType.BillingNote:
      PaymentValidation(_transaction, _isImport);
      break;
  }
}

function PaymentValidation(_transaction, _isImport) {
  let isPaymentActive =
    _transaction.payment.paymentGroupList.find((paymentGroup) => paymentGroup.isPaymentActive == true) === undefined
      ? false
      : true;
  if (_transaction.payment && isPaymentActive) {
    let paymentAllGroupTotal = _transaction.payment.paymentAllGroupTotal.ToNumber().ToAccountingRoundUpNumber();
    let netAmount = _transaction.transactionSummary.remainPaymentNetAmount.ToNumber().ToAccountingRoundUpNumber();

    let paymentAmountValidate = false;
    let netAmountBankAccountValidate = false;

    if (
      (_transaction.transactionType === Enums.TransactionType.Receipt &&
        _transaction.financeType === Enums.FinanceType.InFlow) ||
      (_transaction.transactionType === Enums.TransactionType.CreditNote && _transaction.reference.referenceId > 0) ||
      _transaction.transactionType === Enums.TransactionType.BillingNote
    ) {
      paymentAmountValidate = paymentAllGroupTotal !== netAmount;
    } else {
      paymentAmountValidate = paymentAllGroupTotal > netAmount;
    }
    let paymentGroupValidate =
      _transaction.payment.paymentGroupList.find((paymentGroup) => paymentGroup.validateError == true) === undefined
        ? false
        : true;

    let paymentGroupDateValidate = false;

    if (!_isImport) {
      paymentGroupDateValidate =
        _transaction.payment.paymentGroupList.find((paymentGroup) => !paymentGroup.paymentGroupDate) === undefined
          ? false
          : true;
    }

    _transaction.payment.isValidateError =
      paymentGroupValidate || paymentAmountValidate || paymentGroupDateValidate || netAmountBankAccountValidate;
  } else {
    _transaction.payment.isValidateError = false;
  }
}
function IsTransactionValidateTransactionItem(_transaction) {
  let isCanValidate = true;
  switch (_transaction.transactionType) {
    case Enums.TransactionType.Receipt:
      if (
        _transaction.reference.referenceTypeId === Enums.TransactionType.Invoice ||
        _transaction.reference.referenceTypeId === Enums.TransactionType.BillingNote
      ) {
        isCanValidate = false;
      }
      break;
  }
  return isCanValidate;
}
function TransactionItemListValidate(_transaction, _isImport) {
  if (
    IsTransactionValidateTransactionItem(_transaction) &&
    _transaction.transactionItemList &&
    _transaction.transactionItemList.length > 0
  ) {
    let countTransactionItemEmpty = 0;
    let isValidateError = false;
    _transaction.transactionItemList.forEach((transactionItem) => {
      if (
        (!transactionItem.isDescriptionOnly &&
          transactionItem.productTemplate.id === 0 &&
          transactionItem.account.id === 0 &&
          transactionItem.description.text === "" &&
          transactionItem.price.value.ToNumber() === 0 &&
          transactionItem.discount.value.ToNumber() === 0) ||
        (transactionItem.isDescriptionOnly && transactionItem.description.text === "")
      ) {
        countTransactionItemEmpty += 1;
      } else if (transactionItem.isValidateError || transactionItem.description.text === "") {
        isValidateError = true;
      }
    });

    if (_transaction.transactionItemList.length === countTransactionItemEmpty) {
      _transaction.isValidateError = true;
    } else {
      _transaction.isValidateError = isValidateError;
    }

    if (_isImport) {
      if (_transaction.contact.id === 0) {
        _transaction.isValidateError = true;
      }
      if (
        _transaction.transactionType === Enums.TransactionType.Receipt &&
        (_transaction.payment.paymentGroupList[0].paymentTransactionBankAccountList[0].bankAccountId === 0 ||
          _transaction.payment.paymentGroupList[0].paymentTransactionBankAccountList[0].bankAccountId === "")
      ) {
        _transaction.isValidateError = true;
      }
    }
  }
}

function SummaryValidation(_transaction) {
  let transactionSummaryModel = GetTransactionSummary(_transaction);
  let transactionItemModel = GetTransactionItemSummary(_transaction);
  let transactionDiscountValue = _transaction.transactionDiscount.value.ToNumber();

  if (transactionSummaryModel.transactionSummary.sameProductVatTypeId === Enums.ProductVatType.NotDefined) {
    _transaction.transactionDiscount.disabled = true;
  } else {
    _transaction.transactionDiscount.disabled = false;
    let transactionItemFindError = _transaction.transactionItemList.find(
      (transactionItem) => transactionItem.discount.validateError === true
    );
    let isTransactionItemDiscountError = transactionItemFindError === undefined ? false : true;
    if (!isTransactionItemDiscountError) {
      if (transactionItemModel.total === 0) {
        _transaction.transactionDiscount.validateError = transactionDiscountValue > 0;
      } else {
        if (_transaction.transactionDiscount.discountType == Enums.DiscountType.Percent) {
          _transaction.transactionDiscount.validateError = transactionDiscountValue > 100;
        } else {
          _transaction.transactionDiscount.validateError =
            transactionSummaryModel.transactionCurrencySummary.netAmount.ToNumber() < 0 && transactionDiscountValue > 0;
        }
      }
      if (transactionDiscountValue < 0) {
        _transaction.transactionDiscount.validateError = true;
      }
    }
  }
}

function ValidateTransactionItemPriceDefaultCase(transactionItem) {
  let validateError =
    transactionItem.price.value.ToNumber() > inputMaxNumber ||
    transactionItem.price.value.ToNumber() < inputMinNumber ||
    (transactionItem.price.value.ToNumber() < 0 &&
      transactionItem.productTemplate.id != 0 &&
      transactionItem.productTemplate.productTypeId === Enums.ProductType.Inventory);
  return validateError;
}

function ValidateTransactionItemAmountDefaultCase(transactionItem) {
  let validateError =
    transactionItem.amount.value.ToNumber() > inputMaxNumber || transactionItem.amount.value.ToNumber() < 0;
  return validateError;
}
function IsPurchaseOrderAsset(_transaction) {
  return (
    _transaction.transactionType == Enums.TransactionType.Quotation &&
    _transaction.financeType == Enums.FinanceType.OutFlow &&
    _transaction.transactionItemType == Enums.TransactionItemType.Asset
  );
}
function IsPurchaseAsset(_transaction) {
  return (
    _transaction.transactionType == Enums.TransactionType.Invoice &&
    _transaction.financeType == Enums.FinanceType.OutFlow &&
    _transaction.expenseType == Enums.ExpenseType.PurchaseAsset
  );
}
function TransactionItemValidation(transactionItem, _transaction, _isImport) {
  if (!_isImport) {
    transactionItem.description.validateError = transactionItem.description.text.toString().length > 1000;
  }

  if (!transactionItem.isDescriptionOnly) {
    if (IsPurchaseAsset(_transaction)) {
      transactionItem.fixedAssetTemplate.validateError =
        transactionItem.fixedAssetTemplate.id == 0 && !transactionItem.fixedAssetTemplate.isService;
    }

    if (
      _transaction.transactionType == Enums.TransactionType.Invoice &&
      _transaction.financeType == Enums.FinanceType.InFlow &&
      _transaction.expenseType == Enums.ExpenseType.PurchaseAsset
    ) {
      transactionItem.fixedAssetTemplate.validateError = transactionItem.fixedAssetTemplate.id == 0;
      if (!transactionItem.fixedAsset.disabled && transactionItem.fixedAssetTemplate.id > 0) {
        transactionItem.fixedAsset.validateError = transactionItem.fixedAsset.id == 0;
      } else {
        transactionItem.fixedAsset.validateError = false;
      }
    }

    if (
      _transaction.transactionType == Enums.TransactionType.TaxInvoice &&
      _transaction.financeType == Enums.FinanceType.InFlow &&
      _transaction.transactionItemType == Enums.TransactionItemType.Asset
    ) {
      transactionItem.fixedAssetTemplate.validateError = transactionItem.fixedAssetTemplate.id == 0;
      if (!transactionItem.fixedAsset.disabled && transactionItem.fixedAssetTemplate.id > 0) {
        transactionItem.fixedAsset.validateError = transactionItem.fixedAsset.id == 0;
      } else {
        transactionItem.fixedAsset.validateError = false;
      }
    }

    if (
      _transaction.transactionType == Enums.TransactionType.Receipt &&
      _transaction.financeType == Enums.FinanceType.InFlow &&
      _transaction.transactionItemType == Enums.TransactionItemType.Asset
    ) {
      transactionItem.fixedAssetTemplate.validateError = transactionItem.fixedAssetTemplate.id == 0;
      if (!transactionItem.fixedAsset.disabled && transactionItem.fixedAssetTemplate.id > 0) {
        transactionItem.fixedAsset.validateError = transactionItem.fixedAsset.id == 0;
      } else {
        transactionItem.fixedAsset.validateError = false;
      }
    }
  }

  if (_transaction.transactionType == Enums.TransactionType.CreditNote && _transaction.reference.referenceId > 0) {
    transactionItem.amount.validateError =
      transactionItem.amount.value.ToNumber() > transactionItem.referenceAmount.ToNumber() ||
      transactionItem.amount.value.ToNumber() < 0;

    transactionItem.price.validateError =
      transactionItem.price.disabled || transactionItem.isDescriptionOnly
        ? false
        : transactionItem.price.value.ToNumber() > transactionItem.referencePrice.ToNumber() ||
          transactionItem.price.value.ToNumber() <= 0;
  } else if (
    _transaction.transactionType == Enums.TransactionType.Invoice &&
    _transaction.financeType == Enums.FinanceType.OutFlow &&
    _transaction.reference.referenceTypeId == Enums.TransactionType.Quotation &&
    _transaction.reference.referenceId > 0 &&
    transactionItem.checked.value &&
    transactionItem.referenceQuotationItemId > 0
  ) {
    let settingQuotationPartial = _transaction.merchantSetting.settingQuotationPartial;
    if (settingQuotationPartial.editAmountType == Enums.SettingPartialQuotationEditType.None) {
      transactionItem.amount.validateError =
        transactionItem.amount.value.ToNumber() !== transactionItem.referenceAmount.ToNumber() ||
        transactionItem.amount.value.ToNumber() < 0;
    } else if (settingQuotationPartial.editAmountType == Enums.SettingPartialQuotationEditType.CanEdit) {
      transactionItem.amount.validateError =
        transactionItem.amount.value.ToNumber() > transactionItem.referenceAmount.ToNumber() ||
        transactionItem.amount.value.ToNumber() < 0;
    } else {
      transactionItem.amount.validateError = ValidateTransactionItemAmountDefaultCase(transactionItem);
    }

    if (settingQuotationPartial.editPriceType == Enums.SettingPartialQuotationEditType.None) {
      transactionItem.price.validateError =
        transactionItem.price.value.ToNumber() !== transactionItem.referencePrice.ToNumber();
    } else if (settingQuotationPartial.editPriceType == Enums.SettingPartialQuotationEditType.CanEdit) {
      transactionItem.price.validateError =
        transactionItem.price.value.ToNumber() > transactionItem.referencePrice.ToNumber();
    } else {
      transactionItem.price.validateError = ValidateTransactionItemPriceDefaultCase(transactionItem);
    }
  } else {
    transactionItem.amount.validateError = ValidateTransactionItemAmountDefaultCase(transactionItem);
    transactionItem.price.validateError = ValidateTransactionItemPriceDefaultCase(transactionItem);
  }

  if (transactionItem.productTemplate.id > 0 && !transactionItem.account.id) {
    transactionItem.account.validateError = true;
  } else {
    transactionItem.account.validateError = false;
  }

  transactionItem.itemWht.validateError =
    transactionItem.itemWht.value !== null &&
    transactionItem.itemPreVatTotal.ToNumber() > 0 &&
    transactionItem.itemWht.value.ToNumber() > transactionItem.itemPreVatTotal.ToNumber()
      ? true
      : false;

  DiscountValidation(transactionItem);

  transactionItem.isAllocationItemError = false;
  if (!transactionItem.isUseTransactionAllocation) {
    if (transactionItem.account.id > 0) {
      if (
        transactionItem.itemNetAmountWithAllocateDiscountTotal.ToNumber() !==
        transactionItem.itemNetAmountWithAllocateDiscountForAllocation.ToNumber()
      ) {
        transactionItem.isAllocationItemError = true;
      }
    } else {
      transactionItem.isUseTransactionAllocation = true;
    }
  }

  if (
    !transactionItem.account.validateError &&
    !transactionItem.description.validateError &&
    !transactionItem.amount.validateError &&
    !transactionItem.price.validateError &&
    !transactionItem.discount.validateError &&
    !transactionItem.itemWht.validateError &&
    !transactionItem.fixedAssetTemplate.validateError &&
    !transactionItem.fixedAsset.validateError &&
    !transactionItem.isAllocationItemError
  ) {
    transactionItem.isValidateError = false;
  } else {
    transactionItem.isValidateError = true;
  }

  if (_transaction.taxStatus.value == Enums.TaxTypeId.None) {
    transactionItem.vatTypeId.disabled = true;
  } else {
    transactionItem.vatTypeId.disabled = false;
  }
}

function SetCreateAllocationTransaction(allocationList) {
  let count = 0;
  let allocationTransactionList = [];
  if (allocationList && allocationList.length > 0) {
    for (let allocation of allocationList) {
      if (!allocation.isArchived && count < 4) {
        count++;
        let allocationTransaction = {
          allocationId: allocation.allocationId,
          allocationItemList: [],
          allocation: allocation,
          isSetDefaultValue: false,
        };
        allocationTransactionList.push(allocationTransaction);
      }
    }
  }
  return allocationTransactionList;
}
function SetEditAllocationTransaction(allocationTransacionRawList, allocationList, financeType) {
  let allocationTransactionList = [];
  if (allocationTransacionRawList && allocationTransacionRawList.length > 0) {
    for (let allocationTransacionRaw of allocationTransacionRawList) {
      if (
        allocationTransacionRaw.allocationId &&
        allocationTransacionRaw.allocationItemList &&
        allocationTransacionRaw.allocationItemList.length > 0
      ) {
        let allocationTransaction = {
          allocationId: allocationTransacionRaw.allocationId,
          allocationItemList: [],
          allocation: allocationList.find((x) => x.id == allocationTransacionRaw.allocationId),
          isSetDefaultValue: true,
        };

        for (let allocationItemRaw of allocationTransacionRaw.allocationItemList) {
          if (allocationItemRaw.allocationItemId > 0) {
            allocationTransaction.allocationItemList.push({
              id: allocationItemRaw.allocationItemId,
              percent: allocationItemRaw.allocationPercent.ToNumber() + "%",
              valueType: allocationItemRaw.allocationValueType,
            });
          }
        }
        if (allocationTransaction.allocationId > 0 && allocationTransaction.allocationItemList.length > 0) {
          allocationTransactionList.push(allocationTransaction);
        }
      }
    }
  }
  let count = 0;
  if (allocationList && allocationList.length > 0) {
    for (let allocation of allocationList) {
      let selectedAllocationTransaction = null;
      if (allocationTransacionRawList && allocationTransacionRawList.length > 0) {
        selectedAllocationTransaction = allocationTransacionRawList.find((x) => x.allocationId == allocation.id);
      }
      if (!allocation.isArchived && count < 4 && !selectedAllocationTransaction) {
        let canAddToArray = false;
        if (financeType === Enums.FinanceType.InFlow) {
          canAddToArray =
            allocation.allocationDocumentFinanceType == Enums.AllocationDocumentFinanceType.Income ||
            allocation.allocationDocumentFinanceType == Enums.AllocationDocumentFinanceType.All;
        } else if (financeType == Enums.FinanceType.OutFlow) {
          canAddToArray =
            allocation.allocationDocumentFinanceType == Enums.AllocationDocumentFinanceType.Expense ||
            allocation.allocationDocumentFinanceType == Enums.AllocationDocumentFinanceType.All;
        }

        if (canAddToArray) {
          count++;
          let allocationTransaction = {
            allocationId: allocation.id,
            allocationItemList: [],
            allocation: allocation,
            isSetDefaultValue: false,
          };

          allocationTransactionList.push(allocationTransaction);
        }
      } else if (selectedAllocationTransaction && !allocation.isArchived) {
        count++;
      }
    }
  }
  return allocationTransactionList;
}
function DiscountValidation(transactionItem) {
  let price = transactionItem.price.value.ToNumber();
  let discount = transactionItem.discount.value.ToNumber();
  if (price >= 0) {
    if (transactionItem.discount.discountTypeId == Enums.DiscountType.Currency) {
      transactionItem.discount.validateError = discount > price ? true : false;
    } else if (transactionItem.discount.discountTypeId == Enums.DiscountType.Percent) {
      transactionItem.discount.validateError = discount > 100 ? true : false;
    }
  } else {
    transactionItem.discount.value = "0.00";
    transactionItem.discount.validateError = false;
  }
}
function GetCreateTransactionItemFromTransactionItem(
  transactionDetailItem,
  transactionType = Enums.TransactionType.None,
  financeType = Enums.FinanceType.None,
  isCanEdit = true,
  expenseType = Enums.ExpenseType.None,
  transactionItemType = Enums.TransactionItemType.None
) {
  let transactionItem = GetCreateTransactionItemDefualt(transactionType, financeType, expenseType, transactionItemType);
  transactionItem.referencePrice = transactionDetailItem.price.ToPeakTransactionItemFormat();
  transactionItem.referenceAmount = transactionDetailItem.amount.ToPeakTransactionItemFormat();
  transactionItem.referenceDescription = transactionDetailItem.description;
  transactionItem.referenceDiscount = transactionDetailItem.discount.ToPeakTransactionItemFormat();
  transactionItem.referenceDiscountType = transactionDetailItem.discountType;
  transactionItem.referenceStockActivityId = transactionDetailItem.referenceStockActivityId;
  transactionItem.isDescriptionOnly = transactionDetailItem.isDescriptionOnly;
  transactionItem.productTemplate.id = transactionDetailItem.productTemplateId;
  transactionItem.referenceProductTemplateId = transactionDetailItem.productTemplateId;
  transactionItem.productTemplate.code = transactionDetailItem.productTemplateCode;
  transactionItem.productTemplate.disabled = !isCanEdit;
  transactionItem.productTemplate.standardPrice = 0;
  transactionItem.fixedAssetTemplate.id = transactionDetailItem.fixAssetTemplateId;
  transactionItem.referenceFixedAssetTemplateId = transactionDetailItem.fixAssetTemplateId;
  transactionItem.fixedAssetTemplate.code = transactionDetailItem.fixAssetTemplateCode;
  transactionItem.fixedAssetTemplate.disabled = !isCanEdit;
  transactionItem.fixedAssetTemplate.isNotAuto = true;
  if (expenseType == Enums.ExpenseType.PurchaseAsset || transactionItemType == Enums.ExpenseType.PurchaseAsset) {
    transactionItem.fixedAssetTemplate.isService = transactionDetailItem.isAcquisitionCost;
  }
  transactionItem.fixedAsset.id = transactionDetailItem.assetId;
  transactionItem.fixedAsset.disabled = !isCanEdit;
  transactionItem.fixedAsset.isNotAuto = true;
  if (transactionItem.productTemplate.id > 0) {
    transactionItem.productTemplate.isNotAuto = true;
  }
  transactionItem.referenceAccountId = transactionDetailItem.accountId;
  transactionItem.account.id = transactionDetailItem.accountId;
  transactionItem.account.code = transactionDetailItem.accountCode;
  if (transactionItem.account.id > 0 || transactionItem.productTemplate.isNotAuto) {
    transactionItem.account.isNotAuto = true;
  }
  if (expenseType == Enums.ExpenseType.PurchaseAsset || transactionItemType == Enums.ExpenseType.PurchaseAsset) {
    transactionItem.account.disabled =
      !isCanEdit || (transactionItem.fixedAssetTemplate.id > 0 && transactionItem.account.id > 0);
  } else {
    transactionItem.account.disabled = !isCanEdit;
  }
  transactionItem.description.text = transactionDetailItem.description;
  transactionItem.description.disabled = !isCanEdit;
  transactionItem.amount.value = transactionDetailItem.amount.ToPeakTransactionItemFormat();
  transactionItem.amount.disabled = !isCanEdit;
  transactionItem.price.value = transactionDetailItem.price.ToPeakTransactionItemFormat();
  transactionItem.price.disabled = !isCanEdit;
  transactionItem.discount.value = transactionDetailItem.discount.ToPeakTransactionItemFormat();
  transactionItem.discount.discountTypeId = transactionDetailItem.discountType;
  transactionItem.discount.disabled = !isCanEdit;
  transactionItem.vatTypeId.value = transactionDetailItem.vatType;
  transactionItem.vatTypeId.disabled = !isCanEdit;
  transactionItem.itemWht.value = transactionDetailItem.whtAmount;
  transactionItem.itemWht.whtAmountType = transactionDetailItem.whtAmountType;
  transactionItem.itemWht.disabled = !isCanEdit;
  if (transactionItem.itemWht.whtAmountType !== 0) {
    transactionItem.itemWht.isNotAuto = true;
  }
  transactionItem.itemNetAmountWithAllocateDiscountTotal = transactionDetailItem.itemNetAmountWithAllocateDiscountTotal;
  transactionItem.itemNetAmountWithAllocateDiscountForAllocation =
    transactionDetailItem.itemNetAmountWithAllocateDiscountForAllocation;

  return transactionItem;
}
function GetCreateTransactionItemForAI(
  transactionDetailItem,
  transactionType,
  financeType,
  expenseType = Enums.ExpenseType.None,
  transactionItemType = Enums.TransactionItemType.None,
  isSetProductTemplate
) {
  let transactionItem = GetCreateTransactionItemDefualt(transactionType, financeType, expenseType, transactionItemType);
  transactionItem.isDescriptionOnly = transactionDetailItem.isDescriptionOnly;
  if (isSetProductTemplate) {
    transactionItem.productTemplate.id = transactionDetailItem.productTemplateId;
    transactionItem.productTemplate.standardPrice = 0;
    if (transactionItem.productTemplate.id > 0) {
      transactionItem.productTemplate.isNotAuto = true;
    }
  }
  transactionItem.account.id = transactionDetailItem.accountId;
  transactionItem.account.code = transactionDetailItem.accountCode;
  if (transactionItem.account.id > 0 || transactionItem.productTemplate.isNotAuto) {
    transactionItem.account.isNotAuto = true;
  }
  transactionItem.description.text = transactionDetailItem.description;
  transactionItem.price.value = transactionDetailItem.price.ToPeakTransactionItemFormat();
  transactionItem.vatTypeId.value = transactionDetailItem.vatType;
  transactionItem.itemWht.value = transactionDetailItem.whtAmount;
  transactionItem.itemWht.whtAmountType = transactionDetailItem.whtAmountType;
  if (transactionItem.itemWht.whtAmountType !== 0) {
    transactionItem.itemWht.isNotAuto = true;
  }
  return transactionItem;
}
function GetCreateTransactionItemForAIChartOfAccount(
  chartOfAccountId,
  transactionType,
  financeType,
  expenseType = Enums.ExpenseType.None,
  transactionItemType = Enums.TransactionItemType.None
) {
  let transactionItem = GetCreateTransactionItemDefualt(transactionType, financeType, expenseType, transactionItemType);
  transactionItem.account.id = chartOfAccountId;
  transactionItem.account.isNotAuto = false;
  return transactionItem;
}
function GetCreateTransactionItemDefualt(
  transactionType,
  financeType,
  expenseType = Enums.ExpenseType.None,
  transactionItemType = Enums.TransactionItemType.None
) {
  let hiddenProduct = false;
  let hiddenAssetTemplate = false;
  let hiddenAccount = false;
  let hiddenAsset = false;
  let hiddenAmount = false;
  let hiddenDiscount = false;
  let disabledAccount = false;

  if (financeType == Enums.FinanceType.InFlow) {
    if (expenseType == Enums.ExpenseType.Expense) {
      hiddenAssetTemplate = true;
      hiddenAsset = true;
    } else if (expenseType == Enums.ExpenseType.PurchaseInventory) {
      hiddenAssetTemplate = true;
      hiddenAsset = true;
    } else if (expenseType == Enums.ExpenseType.PurchaseAsset) {
      hiddenProduct = true;
      hiddenAccount = true;
      hiddenAmount = true;
    } else if (transactionItemType == Enums.TransactionItemType.Asset) {
      hiddenProduct = true;
      hiddenAccount = true;
      hiddenAmount = true;
    } else {
      hiddenAssetTemplate = true;
      hiddenAsset = true;
    }
  } else if (financeType == Enums.FinanceType.OutFlow) {
    if (expenseType == Enums.ExpenseType.Expense) {
      hiddenProduct = true;
      hiddenAssetTemplate = true;
      hiddenAsset = true;
    } else if (expenseType == Enums.ExpenseType.PurchaseInventory) {
      hiddenAssetTemplate = true;
      hiddenAsset = true;
    } else if (expenseType == Enums.ExpenseType.PurchaseAsset) {
      hiddenProduct = true;
      hiddenAsset = true;
      disabledAccount = true;
    } else if (transactionItemType == Enums.TransactionItemType.Inventory) {
      hiddenAssetTemplate = true;
      hiddenAsset = true;
    } else if (transactionItemType == Enums.TransactionItemType.Asset) {
      hiddenProduct = true;
      hiddenAsset = true;
      disabledAccount = true;
    } else {
      hiddenAssetTemplate = true;
      hiddenAsset = true;
    }
  }

  if (transactionType == Enums.TransactionType.CreditNote) {
    hiddenDiscount = true;
  }

  return {
    isImportEnableEdit: false,
    isDescriptionOnly: false,
    isValidateError: false,
    referencePrice: 0,
    referenceAmount: 0,
    referenceDescription: "",
    referenceDiscount: 0,
    referenceDiscountType: Enums.DiscountType.Currency,
    referenceStockActivityId: 0,
    checked: {
      value: true,
      hidden: true,
    },
    productTemplate: {
      id: 0,
      code: "",
      name: "",
      disabled: false,
      hidden: hiddenProduct,
      productTypeId: 2,
      isNotAuto: false,
      validateError: false,
    },
    fixedAssetTemplate: {
      id: 0,
      code: "",
      name: "",
      disabled: false,
      hidden: hiddenAssetTemplate,
      scarpAmount: 0,
      isNotAuto: false,
      validateError: false,
      isService: false,
    },
    fixedAsset: {
      id: 0,
      code: "",
      name: "",
      disabled: false,
      hidden: hiddenAsset,
      isNotAuto: false,
      validateError: false,
    },
    account: {
      id: 0,
      code: "",
      name: "",
      hidden: hiddenAccount,
      taxIncomeTypeId: 0,
      disabled: disabledAccount,
      isNotAuto: false,
      validateError: false,
    },
    description: {
      text: "",
      disabled: false,
      validateError: false,
    },
    unit: {
      id: 0,
      name: "",
      disabled: false,
    },
    amount: {
      value: "1.00",
      disabled: false,
      validateError: false,
      hidden: hiddenAmount,
    },
    price: {
      value: "0.00",
      disabled: false,
      validateError: false,
    },
    discount: {
      value: "0.00",
      disabled: false,
      discountTypeId: 0,
      validateError: false,
      hidden: hiddenDiscount,
    },
    vatTypeId: {
      value: 3,
      disabled: false,
      isSuggestion: false,
      validateError: false,
    },
    itemPreVatTotal: "0.00",
    itemVatTotal: "0.00",
    itemNetTotal: "0.00",
    itemWht: {
      text: "",
      value: null,
      percent: 0,
      whtAmountType: -2,
      disabled: false,
      validateError: false,
      isNotAuto: false,
    },
    isUseTransactionAllocation: true,
    itemNetAmountWithAllocateDiscountForAllocation: 0,
    itemNetAmountWithAllocateDiscountTotal: 0,
    isAllocationItemError: false,
    allocationTransactionList: [],
    remainStock: {
      value: 0,
      isProduct: false,
      lastestDate: null,
    },
  };
}
function GetCreateTransactionSummaryDefualt(isEditVatDisabled = false) {
  return {
    vatExemptedTotal: "0.00",
    zeroVatTotal: "0.00",
    vat: {
      preVatTotalDefualt: "0.00",
      preVatTotal: "0.00",
      vatTotalDefualt: "0.00",
      vatTotal: "0.00",
      disabled: isEditVatDisabled,
      isActive: false,
      vatTotalBeforeEdit: "0.00",
    },
    netAmount: "0.00",
    paymentWht: {
      whtTotal: 0,
      paymentNetAmount: 0,
      isShow: false,
    },
    subTotalForCalculateWht: 0,
    isNoneOrNotSpecifyWht: Enums.WhtAmountType.NotSpecify.value,
    remainPaymentNetAmount: 0,
    remainWhtPaymentNetAmount: 0,
    sameProductVatType: 0,
    isServiceOnly: false,
    sameProductVatTypeIdTransactionItemTypeProduct: 0,
  };
}
function GetCreateTransactionCurrencySummaryDefualt(isEditVatDisabled = false) {
  return {
    vatExemptedTotal: "0.00",
    zeroVatTotal: "0.00",
    vat: {
      preVatTotalDefualt: "0.00",
      preVatTotal: "0.00",
      vatTotalDefualt: "0.00",
      vatTotal: "0.00",
      disabled: isEditVatDisabled,
      isActive: false,
      vatTotalBeforeEdit: "0.00",
    },
    netAmount: "0.00",
    fromCurrencyUId: 0,
    toCurrencyUId: 0,
    disabled: isEditVatDisabled,
    hidden: isEditVatDisabled,
    exchangeRate: 1,
    currencyCode: "THB",
    ratio: 1,
    hiddenExchangeRate: true,
    isGetSuggestionCurrency: false,
    whtTotal: 0,
  };
}
function CalculatePreVatTotalFromEditVatTransaction(transaction) {
  transaction.transactionCurrencySummary.vat.preVatTotal = (
    transaction.transactionCurrencySummary.vat.preVatTotalDefualt.ToNumber() +
    (transaction.transactionCurrencySummary.vat.vatTotalDefualt.ToNumber() -
      transaction.transactionCurrencySummary.vat.vatTotal.ToNumber())
  ).FormatMoney();
  let currencyRatio = transaction.transactionCurrencySummary.ratio;
  let currencyExchangeRates = transaction.transactionCurrencySummary.exchangeRate;
  transaction.transactionSummary.vat.vatTotal = CalculateWithCurrencyUid(
    transaction.transactionCurrencySummary.vat.vatTotal.ToNumber(),
    currencyExchangeRates,
    currencyRatio,
    transaction.transactionCurrencySummary.toCurrencyUId
  ).FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = CalculateWithCurrencyUid(
    transaction.transactionCurrencySummary.vat.preVatTotal.ToNumber(),
    currencyExchangeRates,
    currencyRatio,
    transaction.transactionCurrencySummary.toCurrencyUId
  ).FormatMoney();
}

function GetTransactionItemList(_transaction) {
  let transactionItemList = [];
  if (_transaction.transactionItemList.length > 0) {
    let total = 0;
    let totalForCalculateTransactionDiscount = 0;
    let sameProductVatTypeId = 0;
    let isServiceOnly = false;
    let isHaveProductTemplate = false;
    let isHaveProductTemplateTypeProduct = false;
    let sameProductVatTypeIdTransactionItemTypeProduct = 0;
    let dummyTransactionItemVatTypeId = 0;
    let dummyTransactionItemProductVatTypeId = 0;
    let countTransactionItemWithoutDescriptionOnly = 0;
    let countTransactionItemTypeProductWithoutDescriptionOnly = 0;
    let transactionListForCalculateAllocateDiscountPercent = ConvertTransactionListForCalculateAllocateDiscountPercent(
      _transaction.transactionItemList
    );
    let allocateDiscountPercent = CalculateAllocateDiscountPercent(
      transactionListForCalculateAllocateDiscountPercent,
      _transaction.transactionDiscount.value,
      _transaction.transactionDiscount.discountType,
      _transaction.taxStatus.value
    );
    for (let sequenceNumber = 0; sequenceNumber < _transaction.transactionItemList.length; sequenceNumber++) {
      let _transactionItem = _transaction.transactionItemList[sequenceNumber];
      let isDescriptionOnly = _transactionItem.isDescriptionOnly;
      let accountId = 0;
      let transactionItemPrice = 0;
      let transactionItemAmount = 0;
      let transactionItemDiscount = 0;
      let transactionItemDiscountTypeId = 0;
      let transactionItemVatTypeId = 0;
      let transactionItemWhtAmountTypeId = -2;
      let transactionItemWhtAmount = 0;
      let productTemplateId = 0;
      let transactionItemDescription = _transactionItem.description;
      let fixedAssetTemplateId = 0;
      let transactionItemTotal = 0;
      let transactionItemTypeId = 0;
      let taxIncomeTypeId = 0;
      let transactionItemPreVatAmount = 0;
      let transactionItemVatAmount = 0;
      let discountValue = 0;
      let isAcquisitionCost = false;
      let transactionItemForCalculateProductTotalPrice = ConvertTransactionItemForCalculateProductTotalPrice(
        _transactionItem
      );
      let netAmountWithAllocateDiscount = CalculateProductTotalPrice(
        transactionItemForCalculateProductTotalPrice,
        allocateDiscountPercent,
        _transaction.transactionCurrencySummary.toCurrencyUId,
        _transaction.transactionCurrencySummary.exchangeRate,
        _transaction.transactionCurrencySummary.ratio,
        _transaction.taxStatus.value,
        _transaction.issueTaxInvoice.value,
        _transaction.transactionType,
        _transaction.financeType,
        false
      );

      if (!isDescriptionOnly) {
        countTransactionItemWithoutDescriptionOnly++;
        if (_transaction.transactionType != Enums.TransactionType.BillingNote) {
          accountId = _transactionItem.account.id.ToNumber();
          transactionItemPrice = _transactionItem.price.value.ToNumber();
          transactionItemAmount = _transactionItem.amount.value.ToNumber();
          taxIncomeTypeId = _transactionItem.account.taxIncomeTypeId.ToNumber();
          discountValue = _transactionItem.discount.value;
          if (_transactionItem.discount.discountTypeId == 1) {
            transactionItemDiscount = discountValue.ToNumber();
            transactionItemDiscountTypeId = 1;
          } else {
            transactionItemDiscount = discountValue.ToNumber();
            transactionItemDiscountTypeId = 0;
          }
          transactionItemVatTypeId = _transactionItem.vatTypeId.value;
          productTemplateId = _transactionItem.productTemplate.id;
          fixedAssetTemplateId = _transactionItem.fixedAssetTemplate.id;
          isAcquisitionCost = _transactionItem.fixedAssetTemplate.isService;
          transactionItemWhtAmountTypeId = _transactionItem.itemWht.whtAmountType;
          _transactionItem.itemWht.percent = GetTransactionItemWhtPercent(transactionItemWhtAmountTypeId);
        }

        if (_transaction.taxStatus.value == Enums.TaxTypeId.None) {
          _transactionItem.vatTypeId.value = Enums.ProductVatType.None;
        }
        if (countTransactionItemWithoutDescriptionOnly === 1) {
          dummyTransactionItemVatTypeId = transactionItemVatTypeId;
          sameProductVatTypeId = transactionItemVatTypeId;
        }
        if (dummyTransactionItemVatTypeId !== transactionItemVatTypeId) {
          sameProductVatTypeId = 0;
        }
        if (productTemplateId > 0) {
          transactionItemTypeId = _transactionItem.productTemplate.productTypeId;
        } else if (fixedAssetTemplateId > 0) {
          transactionItemTypeId = _transactionItem.fixedAssetTemplate.fixedAssetTypeId;
        }
        if (productTemplateId > 0 || fixedAssetTemplateId > 0) {
          isHaveProductTemplate = true;
          if (transactionItemTypeId == Enums.ProductTemplateType.Product) {
            countTransactionItemTypeProductWithoutDescriptionOnly++;
            isHaveProductTemplateTypeProduct = true;
            if (countTransactionItemTypeProductWithoutDescriptionOnly === 1) {
              dummyTransactionItemProductVatTypeId = transactionItemVatTypeId;
              sameProductVatTypeIdTransactionItemTypeProduct = transactionItemVatTypeId;
            }

            if (dummyTransactionItemProductVatTypeId !== transactionItemVatTypeId) {
              sameProductVatTypeIdTransactionItemTypeProduct = 0;
            }
          }

          if (transactionItemTypeId == Enums.ProductTemplateType.Service && !isHaveProductTemplateTypeProduct) {
            isServiceOnly = true;
          } else {
            isServiceOnly = false;
          }
        }

        if (accountId > 0 && !isHaveProductTemplate) {
          isServiceOnly = true;
        }

        let transactionItemPriceTotal = 0;

        if (transactionItemDiscountTypeId === 1) {
          transactionItemPriceTotal = peakUtility.PeakOperatorSubtract(
            transactionItemPrice,
            peakUtility.PeakOperatorDivide(
              peakUtility.PeakOperatorMultiply(transactionItemPrice, transactionItemDiscount),
              100
            )
          );
        } else {
          transactionItemPriceTotal = peakUtility.PeakOperatorSubtract(transactionItemPrice, transactionItemDiscount);
        }
        transactionItemTotal = peakUtility.PeakOperatorMultiply(transactionItemPriceTotal, transactionItemAmount);
        total = peakUtility.PeakOperatorAdd(total, transactionItemTotal);
        totalForCalculateTransactionDiscount = peakUtility.PeakOperatorAdd(
          totalForCalculateTransactionDiscount,
          transactionItemTotal > 0 ? transactionItemTotal : 0
        );
        if (_transaction.taxStatus.value === Enums.TaxTypeId.IncludeTax) {
          if (_transactionItem.vatTypeId.value === Enums.ProductVatType.SevenPercent) {
            transactionItemPreVatAmount = peakUtility.PeakOperatorMultiply(
              peakUtility.PeakOperatorDivide(transactionItemTotal, peakUtility.PeakOperatorAdd(100, 7)),
              100
            );
            transactionItemVatAmount = peakUtility.PeakOperatorSubtract(
              transactionItemTotal,
              transactionItemPreVatAmount
            );
          } else {
            transactionItemPreVatAmount = transactionItemTotal;
          }
        } else {
          transactionItemPreVatAmount = transactionItemTotal;
          if (
            _transaction.transactionType != Enums.TransactionType.BillingNote &&
            _transactionItem.vatTypeId.value === Enums.ProductVatType.SevenPercent
          ) {
            transactionItemVatAmount = peakUtility.PeakOperatorMultiply(
              transactionItemTotal,
              peakUtility.PeakOperatorDivide(7, 100)
            );
          }
        }
        if (transactionItemWhtAmountTypeId === Enums.WhtAmountType.NotSpecify.type) {
          transactionItemWhtAmount = null;
          if (_transactionItem.itemWht) {
            _transactionItem.itemWht.value = null;
          }
        } else if (transactionItemWhtAmountTypeId === Enums.WhtAmountType.None.type) {
          transactionItemWhtAmount = 0;
          _transactionItem.itemWht.value = 0;
        } else if (transactionItemWhtAmountTypeId === Enums.WhtAmountType.Custom.type) {
          transactionItemWhtAmount = _transactionItem.itemWht.value ? _transactionItem.itemWht.value.ToNumber() : 0;
        } else {
          _transactionItem.itemWht.value = peakUtility.PeakOperatorDivide(
            peakUtility.PeakOperatorMultiply(transactionItemPreVatAmount, _transactionItem.itemWht.percent),
            100
          );
          transactionItemWhtAmount = _transactionItem.itemWht.value ? _transactionItem.itemWht.value.ToNumber() : 0;
        }
        _transactionItem.itemPreVatTotal = transactionItemPreVatAmount.FormatMoney();
        _transactionItem.itemVatTotal = transactionItemVatAmount.FormatMoney();
        _transactionItem.itemNetTotal = peakUtility
          .PeakOperatorAdd(transactionItemPreVatAmount, transactionItemVatAmount)
          .FormatMoney();
        _transactionItem.itemNetAmountWithAllocateDiscountTotal = netAmountWithAllocateDiscount.FormatMoney();
      }
      let transactionItem = {
        transactionItemTotal: transactionItemTotal,
        price: transactionItemPrice,
        amount: transactionItemAmount,
        accountid: accountId,
        discount: transactionItemDiscount,
        discountType: transactionItemDiscountTypeId,
        vatTypeId: transactionItemVatTypeId,
        whtAmountTypeId: transactionItemWhtAmountTypeId,
        whtAmount: transactionItemWhtAmount,
        productTemplateId: productTemplateId,
        fixAssetTemplateId: fixedAssetTemplateId,
        isAcquisitionCost: isAcquisitionCost,
        description: transactionItemDescription,
        sequenceNumber: sequenceNumber + 1,
        isDescriptionOnly: isDescriptionOnly,
        transactionItemTypeId: transactionItemTypeId,
        taxIncomeTypeId: taxIncomeTypeId,
        preVatAmount: transactionItemPreVatAmount,
        vatAmount: transactionItemVatAmount,
      };
      transactionItemList.push(transactionItem);
    }

    return {
      transactionItemList: transactionItemList,
      total: total,
      sameProductVatTypeId: sameProductVatTypeId,
      sameProductVatTypeIdTransactionItemTypeProduct: sameProductVatTypeIdTransactionItemTypeProduct,
      isServiceOnly: isServiceOnly,
      totalForCalculateTransactionDiscount: totalForCalculateTransactionDiscount,
    };
  }
}

function ConvertTransactionListForCalculateAllocateDiscountPercent(transactionItemList) {
  let transactionListForCalculateAllocateDiscountPercent = [];
  for (const transactionItem of transactionItemList) {
    let _transactionItem = {
      netAmount: transactionItem.itemPreVatTotal ? transactionItem.itemPreVatTotal.ToNumber() : 0,
      vatType: transactionItem.vatTypeId ? transactionItem.vatTypeId.value : Enums.ProductVatType.None,
    };
    transactionListForCalculateAllocateDiscountPercent.push(_transactionItem);
  }
  return transactionListForCalculateAllocateDiscountPercent;
}

function ConvertTransactionListDetailForCalculateAllocateDiscountPercent(taxStatus, transactionItemList) {
  let transactionListForCalculateAllocateDiscountPercent = [];

  if (transactionItemList && transactionItemList.length > 0) {
    for (const transactionItem of transactionItemList) {
      let transactionItemTotal = 0;
      let transactionItemPreVatAmount = 0;
      let transactionItemPrice = transactionItem.price ? transactionItem.price.ToNumber() : 0;
      let transactionItemDiscount = transactionItem.discount ? transactionItem.discount.ToNumber() : 0;
      let transactionItemDiscountTypeId = transactionItem.discountType
        ? transactionItem.discountType
        : Enums.DiscountType.Currency;
      let transactionItemAmount = transactionItem.amount ? transactionItem.amount.ToNumber() : 0;
      let transactionItemPriceTotal = 0;

      if (transactionItemDiscountTypeId === 1) {
        transactionItemPriceTotal = peakUtility.PeakOperatorSubtract(
          transactionItemPrice,
          peakUtility.PeakOperatorDivide(
            peakUtility.PeakOperatorMultiply(transactionItemPrice, transactionItemDiscount),
            100
          )
        );
      } else {
        transactionItemPriceTotal = peakUtility.PeakOperatorSubtract(transactionItemPrice, transactionItemDiscount);
      }

      transactionItemTotal = peakUtility.PeakOperatorMultiply(transactionItemPriceTotal, transactionItemAmount);

      if (taxStatus === Enums.TaxTypeId.IncludeTax) {
        if (transactionItem.vatType === Enums.ProductVatType.SevenPercent) {
          transactionItemPreVatAmount = peakUtility.PeakOperatorMultiply(
            peakUtility.PeakOperatorDivide(transactionItemTotal, peakUtility.PeakOperatorAdd(100, 7)),
            100
          );
        } else {
          transactionItemPreVatAmount = transactionItemTotal;
        }
      } else {
        transactionItemPreVatAmount = transactionItemTotal;
      }

      let _transactionItem = {
        netAmount: transactionItemPreVatAmount,
        vatType: transactionItem.vatType,
      };
      transactionListForCalculateAllocateDiscountPercent.push(_transactionItem);
    }
  }
  return transactionListForCalculateAllocateDiscountPercent;
}

function ConvertTransactionItemForCalculateProductTotalPrice(transactionItem) {
  let transactionItemForCalculateProductTotalPrice = {
    price: transactionItem.price ? transactionItem.price.value.ToNumber() : 0,
    discount: transactionItem.discount ? transactionItem.discount.value.ToNumber() : 0,
    discountType: transactionItem.discount ? transactionItem.discount.discountTypeId : Enums.DiscountType.Currency,
    amount: transactionItem.amount ? transactionItem.amount.value.ToNumber() : 0,
    vatType: transactionItem.vatTypeId ? transactionItem.vatTypeId.value : Enums.ProductVatType.None,
  };
  return transactionItemForCalculateProductTotalPrice;
}

function ConvertTransactionItemDetailForCalculateProductTotalPrice(transactionItem) {
  let transactionItemForCalculateProductTotalPrice = {
    price: transactionItem.price,
    discount: transactionItem.discount,
    discountType: transactionItem.discountType,
    amount: transactionItem.amount,
    vatType: transactionItem.vatType,
  };
  return transactionItemForCalculateProductTotalPrice;
}

function CalculateAllocateDiscountPercent(transactionItemList, transactionDiscount, transctionDiscountType, taxStatus) {
  let allProductVatType = Enums.ProductVatType.None;
  let allocateDiscountPercent = 0;
  transactionDiscount = transactionDiscount ? transactionDiscount.ToNumber() : 0;
  if (transactionDiscount != 0) {
    if (transctionDiscountType == Enums.DiscountType.Currency) {
      let allProductNetAmount = 0;
      for (const item of transactionItemList) {
        if (item.netAmount > 0) {
          allProductNetAmount += item.netAmount;
          allProductVatType = item.vatType;
        }
      }
      if (taxStatus == Enums.TaxTypeId.IncludeTax) {
        if (allProductVatType == Enums.ProductVatType.SevenPercent) {
          transactionDiscount = transactionDiscount / ((100 + vatPercent) / 100);
        }
      }
      allocateDiscountPercent = allProductNetAmount != 0 ? (transactionDiscount * 100) / allProductNetAmount : 0;
    } else {
      allocateDiscountPercent = transactionDiscount;
    }
  }
  return allocateDiscountPercent;
}

function GetAllocationItemListWithOutZeroPercent(allocation) {
  let allocationItemList = [];

  if (allocation.allocationItemList && allocation.allocationItemList.length > 0) {
    allocation.allocationItemList.forEach((allocationItem) => {
      if (allocationItem.allocationItemId > 0 && allocationItem.allocationPercent > 0) {
        allocationItemList.push(allocationItem);
      }
    });
  }

  return allocationItemList;
}

function GetAllocationListWithOutZeroPercent(allocationTransactionList) {
  let allocationList = [];

  if (allocationTransactionList && allocationTransactionList.length > 0) {
    allocationTransactionList.forEach((allocation) => {
      let allocationItemList = GetAllocationItemListWithOutZeroPercent(allocation);
      if (allocationItemList.length > 0) {
        let allocationTemplate = {
          allocationId: allocation.allocationId,
          allocationItemList: allocationItemList,
        };
        allocationList.push(allocationTemplate);
      }
    });
  }

  return allocationList;
}

function CalculateProductTotalPrice(
  transactionItem,
  allocateDiscountPercent,
  transactionToCurrencyUId,
  transactionExchangeRate,
  transactionRatio,
  transactionTaxStatus,
  isMerchantVat,
  transactionType,
  financeType,
  isCalculateCurrency = true
) {
  let productPrice = transactionItem.price;

  if (transactionItem.discount != 0) {
    let productDiscount = 0;
    if (transactionItem.discountType == Enums.DiscountType.Percent) {
      productDiscount = (productPrice * transactionItem.discount) / 100;
    } else {
      productDiscount = transactionItem.discount;
    }
    productPrice = productPrice - productDiscount;
  }
  let productNetAmountWithAllocateDiscount = productPrice * transactionItem.amount;
  if (transactionToCurrencyUId != 0 && isCalculateCurrency) {
    productNetAmountWithAllocateDiscount =
      (productNetAmountWithAllocateDiscount * transactionExchangeRate) / transactionRatio;
  }
  if (transactionTaxStatus != Enums.TaxTypeId.ExcludeTax) {
    if (transactionItem.vatType == Enums.ProductVatType.SevenPercent) {
      productNetAmountWithAllocateDiscount = (productNetAmountWithAllocateDiscount / (100 + vatPercent)) * 100;
    }
  }
  if (allocateDiscountPercent != 0 && productNetAmountWithAllocateDiscount > 0) {
    productNetAmountWithAllocateDiscount =
      productNetAmountWithAllocateDiscount * ((100 - allocateDiscountPercent) / 100);
  }

  return productNetAmountWithAllocateDiscount;
}

function GetTransactionItemWhtPercent(whtAmountType) {
  let transactionItemWhtPercent = 0;
  switch (whtAmountType) {
    case Enums.WhtAmountType.NotSpecify.type:
      transactionItemWhtPercent = Enums.WhtAmountType.NotSpecify.value;
      break;
    case Enums.WhtAmountType.None.type:
      transactionItemWhtPercent = Enums.WhtAmountType.None.value;
      break;
    case Enums.WhtAmountType.ZeroPointSevenFive.type:
      transactionItemWhtPercent = Enums.WhtAmountType.ZeroPointSevenFive.value;
      break;
    case Enums.WhtAmountType.OnePercent.type:
      transactionItemWhtPercent = Enums.WhtAmountType.OnePercent.value;
      break;
    case Enums.WhtAmountType.OnePointFivePercent.type:
      transactionItemWhtPercent = Enums.WhtAmountType.OnePointFivePercent.value;
      break;
    case Enums.WhtAmountType.TwoPercent.type:
      transactionItemWhtPercent = Enums.WhtAmountType.TwoPercent.value;
      break;
    case Enums.WhtAmountType.ThreePercent.type:
      transactionItemWhtPercent = Enums.WhtAmountType.ThreePercent.value;
      break;
    case Enums.WhtAmountType.FivePercent.type:
      transactionItemWhtPercent = Enums.WhtAmountType.FivePercent.value;
      break;
    case Enums.WhtAmountType.TenPercent.type:
      transactionItemWhtPercent = Enums.WhtAmountType.TenPercent.value;
      break;
    case Enums.WhtAmountType.FifteenPercent.type:
      transactionItemWhtPercent = Enums.WhtAmountType.FifteenPercent.value;
      break;
    case Enums.WhtAmountType.Custom.type:
      transactionItemWhtPercent = Enums.WhtAmountType.Custom.value;
      break;
  }
  return transactionItemWhtPercent;
}
function GetTransactionItemSummary(_transaction) {
  let vatExemptedTotal = 0;
  let zeroVatTotal = 0;
  let sevenVatTotal = 0;
  let whtTotal = 0;

  let transactionItemModel = GetTransactionItemList(_transaction);
  let isOnlyNoneOrNotSpecifyWht =
    transactionItemModel.transactionItemList.filter(
      (transactionItem) => transactionItem.whtAmount > 0 || transactionItem.whtAmount < 0
    ).length > 0
      ? false
      : true;
  let isHaveSomeNotSpecifyWht =
    transactionItemModel.transactionItemList.filter(
      (transactionItem) => transactionItem.whtAmountTypeId === Enums.WhtAmountType.NotSpecify.type
    ).length > 0;
  let isNoneOrNotSpecifyWht = isHaveSomeNotSpecifyWht && isOnlyNoneOrNotSpecifyWht;
  let subTotalForCalculate = 0;
  for (let transactionItem of transactionItemModel.transactionItemList) {
    let discountTransactionPerProduct = 0;
    if (transactionItem.transactionItemTotal > 0) {
      if (_transaction.transactionDiscount.discountType === 1) {
        discountTransactionPerProduct = peakUtility.PeakOperatorMultiply(
          peakUtility.PeakOperatorDivide(_transaction.transactionDiscount.value, 100),
          transactionItem.transactionItemTotal
        );
      } else {
        discountTransactionPerProduct = peakUtility.PeakOperatorMultiply(
          peakUtility.PeakOperatorDivide(
            transactionItem.transactionItemTotal,
            transactionItemModel.totalForCalculateTransactionDiscount
          ),
          _transaction.transactionDiscount.value
        );
      }
    }
    //Depend on taxStatus
    let transactionItemTotalWithDiscount = peakUtility.PeakOperatorSubtract(
      transactionItem.transactionItemTotal,
      discountTransactionPerProduct
    );
    let transactionItemPreVatTotalWithDiscount = 0;
    if (_transaction.taxStatus.value === Enums.TaxTypeId.IncludeTax) {
      let discountForIncludeTax = 0;
      if (transactionItem.vatTypeId === Enums.ProductVatType.SevenPercent) {
        discountForIncludeTax = (discountTransactionPerProduct * 100) / 107;
      } else {
        discountForIncludeTax = discountTransactionPerProduct;
      }
      transactionItemPreVatTotalWithDiscount = peakUtility.PeakOperatorSubtract(
        transactionItem.preVatAmount,
        discountForIncludeTax
      );
    } else {
      transactionItemPreVatTotalWithDiscount = peakUtility.PeakOperatorSubtract(
        transactionItem.preVatAmount,
        discountTransactionPerProduct
      );
    }

    let whtTransactionItemWithDiscount = 0;
    if (transactionItem.whtAmount != null && transactionItem.transactionItemTotal != 0) {
      whtTransactionItemWithDiscount = peakUtility.PeakOperatorMultiply(
        transactionItem.whtAmount,
        peakUtility.PeakOperatorDivide(transactionItemTotalWithDiscount, transactionItem.transactionItemTotal)
      );
    }
    whtTotal = peakUtility.PeakOperatorAdd(whtTransactionItemWithDiscount, whtTotal);
    if (isNoneOrNotSpecifyWht && transactionItem.whtAmountTypeId === Enums.WhtAmountType.NotSpecify.type) {
      subTotalForCalculate = peakUtility.PeakOperatorAdd(subTotalForCalculate, transactionItemPreVatTotalWithDiscount);
    } else if (!isNoneOrNotSpecifyWht && (transactionItem.whtAmount > 0 || transactionItem.whtAmount < 0)) {
      subTotalForCalculate = peakUtility.PeakOperatorAdd(subTotalForCalculate, transactionItemPreVatTotalWithDiscount);
    }

    switch (transactionItem.vatTypeId.ToNumber()) {
      case 3:
        sevenVatTotal = peakUtility.PeakOperatorAdd(sevenVatTotal, transactionItemTotalWithDiscount);
        break;
      case 2:
        zeroVatTotal = peakUtility.PeakOperatorAdd(zeroVatTotal, transactionItemTotalWithDiscount);
        break;
      default:
        vatExemptedTotal = peakUtility.PeakOperatorAdd(vatExemptedTotal, transactionItemTotalWithDiscount);
        break;
    }
  }
  let total = peakUtility.PeakOperatorAdd(peakUtility.PeakOperatorAdd(vatExemptedTotal, zeroVatTotal), sevenVatTotal);
  return {
    vatExemptedTotal: vatExemptedTotal,
    zeroVatTotal: zeroVatTotal,
    sevenVatTotal: sevenVatTotal,
    total: total,
    subTotalForCalculate: subTotalForCalculate,
    whtTotal: whtTotal,
    isNoneOrNotSpecifyWht: isNoneOrNotSpecifyWht,
    isServiceOnly: transactionItemModel.isServiceOnly,
    sameProductVatTypeId: transactionItemModel.sameProductVatTypeId,
    sameProductVatTypeIdTransactionItemTypeProduct: transactionItemModel.sameProductVatTypeIdTransactionItemTypeProduct,
  };
}
function GetReferenceTransactionSummary(
  _transaction,
  transactionWht,
  referenceTransactionAmount,
  currencyReferenceTransactionAmount
) {
  if (!_transaction.reference) return;

  if (!_transaction.reference.transactionSummary || !_transaction.reference.transactionCurrency) return;

  let transactionSummary = {
    netAmount: _transaction.reference.transactionSummary.netAmount,
    vatTotal: _transaction.reference.transactionSummary.vatTotal,
    preVatTotal: _transaction.reference.transactionSummary.preVatTotal,
    zeroVatTotal: _transaction.reference.transactionSummary.zeroVatTotal,
    vatExemptedTotal: _transaction.reference.transactionSummary.vatExemptedTotal,
    whtTotal: _transaction.reference.transactionSummary.whtTotal,
    subTotalForCalculateWht: _transaction.reference.transactionSummary.subTotalForCalculateWht,
    isServiceOnly: _transaction.reference.transactionSummary.isServiceOnly,
    isNoneOrNotSpecifyWht: transactionWht.isNoneOrNotSpecifyWht,
    sameProductVatTypeId: transactionWht.sameProductVatTypeId.ToNumber(),
    referenceTransactionAmount: referenceTransactionAmount,
  };

  let transactionCurrencySummary = {
    netAmount: _transaction.reference.transactionCurrency.currencyNetAmount,
    vatTotal: _transaction.reference.transactionCurrency.currencyVatTotal,
    preVatTotal: _transaction.reference.transactionCurrency.currencyPreVatTotal,
    zeroVatTotal: _transaction.reference.transactionCurrency.currencyZeroVatTotal,
    vatExemptedTotal: _transaction.reference.transactionCurrency.currencyVatExemptedTotal,
    whtTotal: _transaction.reference.transactionCurrency.currencyWhtTotal,
    subTotalForCalculateWht: _transaction.reference.transactionCurrency.currencySubTotalForCalculateWht,
    referenceTransactionAmount: currencyReferenceTransactionAmount,
  };

  return { transactionSummary: transactionSummary, transactionCurrencySummary: transactionCurrencySummary };
}
function GetTransactionSummary(_transaction) {
  let taxStatus = _transaction.taxStatus.value;
  let currencyRatio = _transaction.transactionCurrencySummary.ratio;
  let currencyExchangeRates = _transaction.transactionCurrencySummary.exchangeRate;
  let transactionItemSummaryModel = GetTransactionItemSummary(_transaction);
  let transactionWht = {
    subTotalForCalculate: transactionItemSummaryModel.subTotalForCalculate,
    whtTotal: transactionItemSummaryModel.whtTotal,
    isServiceOnly: transactionItemSummaryModel.isServiceOnly,
    isNoneOrNotSpecifyWht: transactionItemSummaryModel.isNoneOrNotSpecifyWht,
    sameProductVatTypeId: transactionItemSummaryModel.sameProductVatTypeId,
    sameProductVatTypeIdTransactionItemTypeProduct:
      transactionItemSummaryModel.sameProductVatTypeIdTransactionItemTypeProduct,
  };

  let vatExemptedTotal = CalculateWithCurrencyUid(
    transactionItemSummaryModel.vatExemptedTotal,
    currencyExchangeRates,
    currencyRatio,
    _transaction.transactionCurrencySummary.toCurrencyUId
  );
  let zeroVatTotal = CalculateWithCurrencyUid(
    transactionItemSummaryModel.zeroVatTotal,
    currencyExchangeRates,
    currencyRatio,
    _transaction.transactionCurrencySummary.toCurrencyUId
  );
  let referenceTransactionAmount = 0;
  let currencyReferenceTransactionAmount = 0;

  if (
    _transaction.transactionType == Enums.TransactionType.CreditNote ||
    _transaction.transactionType == Enums.TransactionType.DebitNote
  ) {
    if (_transaction.transactionReferenceAmount) {
      currencyReferenceTransactionAmount = _transaction.transactionReferenceAmount.value.ToNumber();
      referenceTransactionAmount = CalculateWithCurrencyUid(
        _transaction.transactionReferenceAmount.value.ToNumber(),
        currencyExchangeRates,
        currencyRatio,
        _transaction.transactionCurrencySummary.toCurrencyUId
      );
    }
  }

  if (
    _transaction.transactionType === Enums.TransactionType.CreditNote &&
    (_transaction.reduceDebtType && _transaction.reduceDebtType.value.id === Enums.ReduceDebtType.AllDebts) &&
    _transaction.reference.referenceId > 0
  ) {
    let referenceTransactionSummary = GetReferenceTransactionSummary(
      _transaction,
      transactionWht,
      referenceTransactionAmount,
      currencyReferenceTransactionAmount
    );
    if (referenceTransactionSummary) return referenceTransactionSummary;
  }

  let currencyVatExemptedTotal = transactionItemSummaryModel.vatExemptedTotal.ToAccountingRoundUp();
  let currencyZeroVatTotal = transactionItemSummaryModel.zeroVatTotal.ToAccountingRoundUp();
  let preVatTotal = 0;
  let vat = 0;
  let netAmount = 0;
  let currencyPreVatTotal = 0;
  let currencyVatTotal = 0;
  let currencyNetAmount = 0;

  if (taxStatus.ToNumber() === Enums.TaxTypeId.ExcludeTax) {
    vat = peakUtility
      .PeakOperatorDivide(
        peakUtility.PeakOperatorMultiply(
          CalculateWithCurrencyUid(
            transactionItemSummaryModel.sevenVatTotal,
            currencyExchangeRates,
            currencyRatio,
            _transaction.transactionCurrencySummary.toCurrencyUId
          ),
          vatPercent
        ),
        100
      )
      .ToAccountingRoundUp();
    preVatTotal = CalculateWithCurrencyUid(
      transactionItemSummaryModel.sevenVatTotal,
      currencyExchangeRates,
      currencyRatio,
      _transaction.transactionCurrencySummary.toCurrencyUId
    );
    netAmount = peakUtility
      .PeakOperatorAdd(
        peakUtility.PeakOperatorAdd(
          peakUtility.PeakOperatorAdd(
            preVatTotal.ToAccountingRoundUpNumber(),
            zeroVatTotal.ToAccountingRoundUpNumber()
          ),
          vatExemptedTotal.ToAccountingRoundUpNumber()
        ),
        vat.ToAccountingRoundUpNumber()
      )
      .ToAccountingRoundUp();

    currencyVatTotal = peakUtility
      .PeakOperatorDivide(peakUtility.PeakOperatorMultiply(transactionItemSummaryModel.sevenVatTotal, vatPercent), 100)
      .ToAccountingRoundUp();
    currencyPreVatTotal = transactionItemSummaryModel.sevenVatTotal.ToAccountingRoundUp();
    currencyNetAmount = peakUtility
      .PeakOperatorAdd(
        peakUtility.PeakOperatorAdd(
          peakUtility.PeakOperatorAdd(
            currencyPreVatTotal.ToAccountingRoundUpNumber(),
            currencyZeroVatTotal.ToAccountingRoundUpNumber()
          ),
          currencyVatExemptedTotal.ToAccountingRoundUpNumber()
        ),
        currencyVatTotal.ToAccountingRoundUpNumber()
      )
      .ToAccountingRoundUp();
  } else {
    netAmount = CalculateWithCurrencyUid(
      transactionItemSummaryModel.total,
      currencyExchangeRates,
      currencyRatio,
      _transaction.transactionCurrencySummary.toCurrencyUId
    );
    let totalWithVat = peakUtility.PeakOperatorSubtract(
      peakUtility.PeakOperatorSubtract(netAmount, zeroVatTotal),
      vatExemptedTotal
    );
    vat = peakUtility
      .PeakOperatorMultiply(
        peakUtility.PeakOperatorDivide(totalWithVat, peakUtility.PeakOperatorAdd(100, vatPercent)),
        vatPercent
      )
      .ToAccountingRoundUp();
    preVatTotal = peakUtility
      .PeakOperatorSubtract(
        peakUtility.PeakOperatorSubtract(peakUtility.PeakOperatorSubtract(netAmount, vat), zeroVatTotal),
        vatExemptedTotal
      )
      .ToAccountingRoundUp();

    currencyNetAmount = transactionItemSummaryModel.total.ToAccountingRoundUp();
    let currencyTotalWithVat = peakUtility.PeakOperatorSubtract(
      peakUtility.PeakOperatorSubtract(currencyNetAmount, currencyZeroVatTotal),
      currencyVatExemptedTotal
    );
    currencyVatTotal = peakUtility
      .PeakOperatorMultiply(
        peakUtility.PeakOperatorDivide(currencyTotalWithVat, peakUtility.PeakOperatorAdd(100, vatPercent)),
        vatPercent
      )
      .ToAccountingRoundUp();
    currencyPreVatTotal = peakUtility
      .PeakOperatorSubtract(
        peakUtility.PeakOperatorSubtract(
          peakUtility.PeakOperatorSubtract(currencyNetAmount, currencyVatTotal),
          currencyZeroVatTotal
        ),
        currencyVatExemptedTotal
      )
      .ToAccountingRoundUp();
  }
  let transactionSummary = {
    netAmount: netAmount,
    vatTotal: vat,
    preVatTotal: preVatTotal,
    zeroVatTotal: zeroVatTotal,
    vatExemptedTotal: vatExemptedTotal,
    whtTotal: CalculateWithCurrencyUid(
      transactionWht.whtTotal,
      currencyExchangeRates,
      currencyRatio,
      _transaction.transactionCurrencySummary.toCurrencyUId
    ),
    subTotalForCalculateWht: CalculateWithCurrencyUid(
      transactionWht.subTotalForCalculate,
      currencyExchangeRates,
      currencyRatio,
      _transaction.transactionCurrencySummary.toCurrencyUId
    ),
    isServiceOnly: transactionWht.isServiceOnly,
    isNoneOrNotSpecifyWht: transactionWht.isNoneOrNotSpecifyWht,
    sameProductVatTypeId: transactionWht.sameProductVatTypeId.ToNumber(),
    sameProductVatTypeIdTransactionItemTypeProduct: transactionWht.sameProductVatTypeIdTransactionItemTypeProduct.ToNumber(),
    referenceTransactionAmount: referenceTransactionAmount,
  };

  let transactionCurrencySummary = {
    netAmount: currencyNetAmount,
    vatTotal: currencyVatTotal,
    preVatTotal: currencyPreVatTotal,
    zeroVatTotal: currencyZeroVatTotal,
    vatExemptedTotal: currencyVatExemptedTotal,
    whtTotal: transactionWht.whtTotal.ToAccountingRoundUpNumber(),
    subTotalForCalculateWht: transactionWht.subTotalForCalculate.ToAccountingRoundUpNumber(),
    referenceTransactionAmount: currencyReferenceTransactionAmount,
  };

  return { transactionSummary: transactionSummary, transactionCurrencySummary: transactionCurrencySummary };
}
function SetTransactionSummary(_transaction) {
  let transactionSummaryModel = GetTransactionSummary(_transaction);
  if (!_transaction.isNotCalculateTransactionSummary) {
    _transaction.transactionCurrencySummary.vatExemptedTotal = transactionSummaryModel.transactionCurrencySummary.vatExemptedTotal.FormatMoney();
    _transaction.transactionCurrencySummary.zeroVatTotal = transactionSummaryModel.transactionCurrencySummary.zeroVatTotal.FormatMoney();
    _transaction.transactionCurrencySummary.netAmount = transactionSummaryModel.transactionCurrencySummary.netAmount.FormatMoney();
    _transaction.transactionCurrencySummary.whtTotal = transactionSummaryModel.transactionCurrencySummary.whtTotal.FormatMoney();
    _transaction.transactionSummary.vatExemptedTotal = transactionSummaryModel.transactionSummary.vatExemptedTotal.FormatMoney();
    _transaction.transactionSummary.zeroVatTotal = transactionSummaryModel.transactionSummary.zeroVatTotal.FormatMoney();
    if (!_transaction.isNotAuto) {
      _transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
        transactionSummaryModel.transactionCurrencySummary.preVatTotal;
      _transaction.transactionCurrencySummary.vat.preVatTotal = transactionSummaryModel.transactionCurrencySummary.preVatTotal.FormatMoney();
      _transaction.transactionCurrencySummary.vat.vatTotalDefualt =
        transactionSummaryModel.transactionCurrencySummary.vatTotal;
      _transaction.transactionCurrencySummary.vat.vatTotal = transactionSummaryModel.transactionCurrencySummary.vatTotal.FormatMoney();
      _transaction.transactionSummary.vat.preVatTotalDefualt = transactionSummaryModel.transactionSummary.preVatTotal;
      _transaction.transactionSummary.vat.preVatTotal = transactionSummaryModel.transactionSummary.preVatTotal.FormatMoney();
      _transaction.transactionSummary.vat.vatTotalDefualt = transactionSummaryModel.transactionSummary.vatTotal;
      _transaction.transactionSummary.vat.vatTotal = transactionSummaryModel.transactionSummary.vatTotal.FormatMoney();
      _transaction.transactionSummary.isServiceOnly = transactionSummaryModel.transactionSummary.isServiceOnly;
      _transaction.transactionSummary.isNoneOrNotSpecifyWht =
        transactionSummaryModel.transactionSummary.isNoneOrNotSpecifyWht;
      _transaction.transactionSummary.sameProductVatType =
        transactionSummaryModel.transactionSummary.sameProductVatTypeId;
      _transaction.transactionSummary.sameProductVatTypeIdTransactionItemTypeProduct =
        transactionSummaryModel.transactionSummary.sameProductVatTypeIdTransactionItemTypeProduct;
    }
    _transaction.transactionCurrencySummary.vat.disabled =
      _transaction.transactionSummary.sameProductVatType === Enums.ProductVatType.None;
    _transaction.transactionSummary.vat.disabled =
      _transaction.transactionSummary.sameProductVatType === Enums.ProductVatType.None;
    _transaction.transactionCurrencySummary.vat.isActive = false;
    _transaction.transactionSummary.vat.isActive = false;

    _transaction.transactionSummary.netAmount = transactionSummaryModel.transactionSummary.netAmount.FormatMoney();
    _transaction.transactionSummary.subTotalForCalculateWht =
      transactionSummaryModel.transactionSummary.subTotalForCalculateWht;
    _transaction.transactionSummary.paymentWht = {
      whtTotal: transactionSummaryModel.transactionSummary.whtTotal.FormatMoney(),
      paymentNetAmount: peakUtility
        .PeakOperatorSubtract(
          transactionSummaryModel.transactionSummary.netAmount,
          transactionSummaryModel.transactionSummary.whtTotal
        )
        .FormatMoney(),
      isShow: transactionSummaryModel.transactionSummary.whtTotal != 0,
    };
    _transaction.transactionSummary.remainPaymentNetAmount = transactionSummaryModel.transactionSummary.netAmount;
    _transaction.transactionSummary.remainWhtPaymentNetAmount = transactionSummaryModel.transactionSummary.whtTotal;

    if (
      _transaction.transactionType == Enums.TransactionType.CreditNote ||
      _transaction.transactionType == Enums.TransactionType.DebitNote
    ) {
      if (_transaction.transactionReferenceAmount) {
        _transaction.transactionReferenceAmount.value = transactionSummaryModel.transactionCurrencySummary.referenceTransactionAmount.FormatMoney();
      }
    }
  }
}
function SetIssueTaxInvoiceForImport(_transaction, merchantSetting) {
  let transactionType = _transaction.transactionType;
  let financeType = _transaction.financeType;
  let sameProductVatType = _transaction.transactionSummary.sameProductVatType;

  if (!merchantSetting.isVat) {
    _transaction.issueTaxInvoice.value = false;
  } else if (
    (transactionType === Enums.TransactionType.Invoice || transactionType === Enums.TransactionType.Receipt) &&
    financeType === Enums.FinanceType.InFlow
  ) {
    if (sameProductVatType === Enums.ProductVatType.None && !merchantSetting.canCreateTaxInvoiceNotVat) {
      _transaction.issueTaxInvoice.value = false;
    }
  }
}
function GetCurrencyMenuList() {
  let keys = Object.keys(Enums.CurrencyCode);
  let values = Object.values(Enums.CurrencyCode);
  let currencyList = [];
  for (let index = 0; index < keys.length; index++) {
    currencyList.push({ currencyCode: keys[index], value: values[index] });
  }
  return currencyList;
}
function GetCurrencyCodeByUid(currencyUid) {
  return GetCurrencyMenuList().find((x) => x.value === currencyUid);
}
function CalculateWithCurrencyUid(currencyAmount, exchangeRates, currencyRatio, toCurrencyUid) {
  if (toCurrencyUid === Enums.CurrencyCode.THB) {
    return currencyAmount;
  } else {
    const netAmount = peakUtility.PeakOperatorDivide(
      peakUtility.PeakOperatorMultiply(currencyAmount, exchangeRates),
      currencyRatio
    );
    return netAmount;
  }
}
export default {
  //#region Action for transaction
  OnChangeTransactionItem(transaction) {
    SetTransactionSummary(transaction);
    CheckErrorValueInput(transaction);
  },
  OnHumanChangeTransactionItem(transaction) {
    transaction.isNotAuto = false;
    if (!(transaction.transactionType == Enums.TransactionType.CreditNote && transaction.reference.referenceId > 0)) {
      transaction.issueTaxInvoice.isNotAuto = false;
    }
    SetTransactionSummary(transaction);
    CheckErrorValueInput(transaction);
  },
  OnHumanEvent(transaction) {
    transaction.isNotAuto = false;
  },
  OnChangeWhtPayment({ transaction, paymentGroup, isFromEvent = false, isReturnWhtAmountToPayment = false }) {
    paymentHelper.CalculateWhtAmount(
      transaction.transactionSummary.netAmount.ToNumber(),
      transaction.transactionSummary.subTotalForCalculateWht,
      paymentGroup
    );
    paymentHelper.OnChangeWht(paymentGroup, isFromEvent, isReturnWhtAmountToPayment);
    paymentHelper.CalculateAllPaymentGroupSummary(transaction.payment);
    CheckErrorValueInput(transaction);
  },
  OnChangePaymentGroup(transaction) {
    paymentHelper.CalculateAllPaymentGroupSummary(transaction.payment);
    CheckErrorValueInput(transaction);
  },
  CheckErrorValueInputForCreateTransaction(transaction) {
    CheckErrorValueInput(transaction);
  },
  CheckErrorPaymentGroup(transaction) {
    CheckErrorValueInput(transaction);
  },
  SelectedProductRemainStockOnTransactionItem(transaction, input) {
    if (input.productRemainStock && input.productRemainStock.productTemplateId > 0) {
      transaction.transactionItemList[input.index].remainStock.value = input.productRemainStock.remainStockAmount;
      transaction.transactionItemList[input.index].remainStock.isProduct = true;
      transaction.transactionItemList[input.index].remainStock.lastestDate = input.productRemainStock.lastestStockDate;
    } else {
      transaction.transactionItemList[input.index].remainStock.value = 0;
      transaction.transactionItemList[input.index].remainStock.isProduct = true;
      transaction.transactionItemList[input.index].remainStock.lastestDate = null;
    }
  },
  SelectedPricingProductOnTransactionItem(transaction, input) {
    if (input.pricingProductModel && input.pricingProductModel.productTemplateId > 0) {
      transaction.transactionItemList[input.index].pricingProductModel = input.pricingProductModel;
    } else {
      transaction.transactionItemList[input.index].pricingProductModel = null;
    }
  },
  SetTransactionNumber(transaction, transactionNumber) {
    transaction.number.value = transactionNumber;
  },
  SetTransactionNumberValidateError(transaction, showError) {
    transaction.number.validateError = showError;
  },
  UpdateIsNotAutoTransactionItemList(transaction, transactionItemList) {
    if (transaction.transactionItemList && transaction.transactionItemList.length > 0) {
      for (let transactionItem of transaction.transactionItemList) {
        if (transactionItem.productTemplate.id > 0) {
          transactionItem.productTemplate.isNotAuto = true;
        }
        if (transactionItem.account.id > 0) {
          transactionItem.account.isNotAuto = true;
        }
      }
    }
    transaction.transactionItemList = transactionItemList;
  },
  //#endregion
  GetCreateTransactionItemDefualt(
    transactionType,
    financeType,
    expenseType = Enums.ExpenseType.None,
    transactionItemType = Enums.TransactionItemType.None
  ) {
    return GetCreateTransactionItemDefualt(transactionType, financeType, expenseType, transactionItemType);
  },
  GetCreateTransactionSummaryDefualt(isEditVatDisabled = false) {
    return GetCreateTransactionSummaryDefualt(isEditVatDisabled);
  },
  CalculatePreVatTotalFromEditVatTransaction(transaction) {
    return CalculatePreVatTotalFromEditVatTransaction(transaction);
  },
  SetTransactionSummary(_transaction) {
    return SetTransactionSummary(_transaction);
  },
  SetIssueTaxInvoiceForImport(_transaction, merchantSetting) {
    return SetIssueTaxInvoiceForImport(_transaction, merchantSetting);
  },
  CheckErrorValueInput(transaction, importType = false) {
    return CheckErrorValueInput(transaction, importType);
  },
  TransactionValidationAndRemoveTransactionItemEmpty(_transaction, triggerAlert = true, isImportTransaction = false) {
    return TransactionValidationAndRemoveTransactionItemEmpty(_transaction, triggerAlert, isImportTransaction);
  },
  GetCreditNoteActualTotal(transactionReferenceAmount, vatExemptedTotal, zeroVatTotal, preVatTotal) {
    return GetCreditNoteActualTotal(transactionReferenceAmount, vatExemptedTotal, zeroVatTotal, preVatTotal);
  },
  GetDebitNoteActualTotal(transactionReferenceAmount, vatExemptedTotal, zeroVatTotal, preVatTotal) {
    return GetDebitNoteActualTotal(transactionReferenceAmount, vatExemptedTotal, zeroVatTotal, preVatTotal);
  },
  TransactionValidationDebitNoteCreditNote(_transaction) {
    return TransactionValidationDebitNoteCreditNote(_transaction);
  },
  TransactionValidationInvoice(_transaction) {
    return TransactionValidationInvoice(_transaction);
  },
  BookmarkValidation(_transaction) {
    return BookmarkValidation(_transaction);
  },
  GetTransactionSummary(_transaction) {
    return GetTransactionSummary(_transaction);
  },
  GetCreateTransactionCurrencySummaryDefualt(isEditVatDisabled = false) {
    return GetCreateTransactionCurrencySummaryDefualt(isEditVatDisabled);
  },
  GetCreateTransactionItemFromTransactionItem(
    transactionDetailItem,
    transactionType = Enums.TransactionType.None,
    financeType = Enums.FinanceType.None,
    isCanEdit = true,
    expenseType = Enums.ExpenseType.None,
    transactionItemType = Enums.TransactionItemType.None
  ) {
    return GetCreateTransactionItemFromTransactionItem(
      transactionDetailItem,
      transactionType,
      financeType,
      isCanEdit,
      expenseType,
      transactionItemType
    );
  },
  GetTransactionItemList(transaction) {
    return GetTransactionItemList(transaction);
  },
  GetTransactionItemSummary(_transaction) {
    return GetTransactionItemSummary(_transaction);
  },
  GetCurrencyMenuList() {
    return GetCurrencyMenuList();
  },
  GetCurrencyCodeByUid(_currencyUid) {
    return GetCurrencyCodeByUid(_currencyUid);
  },
  SlideToElementError(transaction) {
    SlideToElementError(transaction);
  },
  GetCreateTransactionItemForAI(
    transactionDetailItem,
    transactionType,
    financeType,
    expenseType = Enums.ExpenseType.None,
    transactionItemType = Enums.TransactionItemType.None,
    isSetProductTemplate
  ) {
    return GetCreateTransactionItemForAI(
      transactionDetailItem,
      transactionType,
      financeType,
      expenseType,
      transactionItemType,
      isSetProductTemplate
    );
  },
  GetTransactionItemWhtPercent(whtAmountType) {
    return GetTransactionItemWhtPercent(whtAmountType);
  },
  GetCreateTransactionItemForAIChartOfAccount(
    chartOfAccountId,
    transactionType,
    financeType,
    expenseType = Enums.ExpenseType.None,
    transactionItemType = Enums.TransactionItemType.None
  ) {
    return GetCreateTransactionItemForAIChartOfAccount(
      chartOfAccountId,
      transactionType,
      financeType,
      expenseType,
      transactionItemType
    );
  },
  SetEditAllocationTransaction(allocationTransacionRawList, allocationList, financeType) {
    return SetEditAllocationTransaction(allocationTransacionRawList, allocationList, financeType);
  },
  TransactionItemValidation(transactionItem, _transaction, _isImport) {
    return TransactionItemValidation(transactionItem, _transaction, _isImport);
  },
  AllocationTransactionEquals(a, b) {
    let allocationTransactionEquals = true;
    if (a && b) {
      if (a.length > b.length) {
        allocationTransactionEquals = a.every((val, index) => JSON.stringify(val) === JSON.stringify(b[index]));
      } else {
        allocationTransactionEquals = b.every((val, index) => JSON.stringify(val) === JSON.stringify(a[index]));
      }
    } else if (!a && !b) {
      allocationTransactionEquals = true;
    } else {
      allocationTransactionEquals = false;
    }
    return allocationTransactionEquals;
  },
  SetCreateAllocationTransaction(allocationList) {
    return SetCreateAllocationTransaction(allocationList);
  },
  SetAllocationTransactionByFinanceType(_allocationTransacionRawList, allocationList, financeType) {
    let allocationTransacionRawList = [];

    if (_allocationTransacionRawList && _allocationTransacionRawList.length > 0) {
      _allocationTransacionRawList.forEach((allocationTemplate) => {
        let allocation = allocationList.find((x) => x.id == allocationTemplate.allocationId);
        if (allocation) {
          switch (financeType) {
            case Enums.FinanceType.InFlow:
              if (
                allocation.allocationDocumentFinanceType == Enums.AllocationDocumentFinanceType.Income ||
                allocation.allocationDocumentFinanceType == Enums.AllocationDocumentFinanceType.All
              ) {
                allocationTransacionRawList.push(allocationTemplate);
              }
              break;
            case Enums.FinanceType.OutFlow:
              if (
                allocation.allocationDocumentFinanceType == Enums.AllocationDocumentFinanceType.Expense ||
                allocation.allocationDocumentFinanceType == Enums.AllocationDocumentFinanceType.All
              ) {
                allocationTransacionRawList.push(allocationTemplate);
              }
              break;
          }
        }
      });
    }

    return allocationTransacionRawList;
  },
  CalculateAllocateDiscountPercent(transactionItemList, transactionDiscount, transctionDiscountType, taxStatus) {
    return CalculateAllocateDiscountPercent(
      transactionItemList,
      transactionDiscount,
      transctionDiscountType,
      taxStatus
    );
  },
  CalculateProductTotalPrice(
    transactionItem,
    allocateDiscountPercent,
    transactionToCurrencyUId,
    transactionExchangeRate,
    transactionRatio,
    transactionTaxStatus,
    isMerchantVat,
    transactionType,
    financeType,
    isCalculateCurrency = true
  ) {
    return CalculateProductTotalPrice(
      transactionItem,
      allocateDiscountPercent,
      transactionToCurrencyUId,
      transactionExchangeRate,
      transactionRatio,
      transactionTaxStatus,
      isMerchantVat,
      transactionType,
      financeType,
      isCalculateCurrency
    );
  },
  ConvertTransactionListDetailForCalculateAllocateDiscountPercent(taxStatus, transactionItemList) {
    return ConvertTransactionListDetailForCalculateAllocateDiscountPercent(taxStatus, transactionItemList);
  },
  ConvertTransactionItemDetailForCalculateProductTotalPrice(transactionItem) {
    return ConvertTransactionItemDetailForCalculateProductTotalPrice(transactionItem);
  },
  CheckVatOptions(vatTypeId) {
    let vatOptions = [
      { name: i18n.t("None"), value: Enums.ProductVatType.None },
      { name: "0%", value: Enums.ProductVatType.ZeroPercent },
      { name: "7%", value: Enums.ProductVatType.SevenPercent },
    ];
    let selectVat = vatOptions.find((item) => item.value == vatTypeId);
    if (!selectVat) {
      selectVat = vatOptions[2];
    }
    return selectVat;
  },
  SetAssetToTransactionCreate(transaction, input) {
    if (transaction.transactionItemList && transaction.transactionItemList.length > 0) {
      transaction.transactionItemList[0].fixedAssetTemplate.code = input.assetTemplate.assetTemplateCode;
      transaction.transactionItemList[0].fixedAssetTemplate.id = input.assetTemplate.id;
      transaction.transactionItemList[0].fixedAsset.code = input.asset.uniqueId;
      transaction.transactionItemList[0].fixedAsset.id = input.asset.id;
    }
  },
  SetAssetTemplateToTransactionCreate(transaction, assetTemplate) {
    if (transaction.transactionItemList && transaction.transactionItemList.length > 0) {
      transaction.transactionItemList[0].fixedAssetTemplate.code = assetTemplate.assetTemplateCode;
      transaction.transactionItemList[0].fixedAssetTemplate.id = assetTemplate.id;
    }
  },
  SetAssetToTransactionEdit(transaction, input) {
    if (transaction.transactionItemList && transaction.transactionItemList.length > 0) {
      transaction.transactionItemList.forEach((transactionItem) => {
        let asset = input.assetList.find((x) => x.id == transactionItem.fixedAsset.id);
        if (asset) {
          let assetTemplate = input.assetTemplateList.find((x) => x.id == asset.assetTemplateId);
          if (assetTemplate) {
            transactionItem.fixedAssetTemplate.code = assetTemplate.assetTemplateCode;
            transactionItem.fixedAssetTemplate.id = assetTemplate.id;

            if (
              transaction.transactionType == Enums.TransactionType.TaxInvoice ||
              (transaction.transactionType == Enums.TransactionType.Receipt &&
                transaction.reference.referenceId > 0 &&
                transaction.reference.referenceTypeId == Enums.ReceiptReferenceType.Invoice)
            ) {
              transactionItem.fixedAsset.code = asset.uniqueId;
              transactionItem.fixedAsset.id = asset.id;
            } else {
              if (asset.saleAssetTransactionId == 0) {
                transactionItem.fixedAsset.code = asset.uniqueId;
                transactionItem.fixedAsset.id = asset.id;
              } else {
                transactionItem.fixedAsset.code = "";
                transactionItem.fixedAsset.id = 0;
              }
            }
          }
        }
      });
    }
  },
  CalculateWithCurrencyUid(currencyAmount, exchangeRates, currencyRatio, toCurrencyUid) {
    return CalculateWithCurrencyUid(currencyAmount, exchangeRates, currencyRatio, toCurrencyUid);
  },
  GetInputMaxMinNumber() {
    return {
      inputMaxNumber: inputMaxNumber,
      inputMinNumber: inputMinNumber,
    };
  },
  GetAllocationListWithOutZeroPercent(allocationTransactionList) {
    return GetAllocationListWithOutZeroPercent(allocationTransactionList);
  },
};
